import { useState, useEffect } from "react";
const { DIPLOMA_OPTIONS, normalizeSalesforceValue } = require("../shared/salesforceDiploma");
const { buildQuestionLookup, isQuestionVisible } = require("../shared/progress");

export default function QuestionSelect({ questionInfo, getNumberFiliereActif, getNumberCritereActif, updateQuestionValue, updateQuestionVisible, updateQuestionSelectPays, sousCritereIndex, questionIndex, data, updateFiltreGeneral, sendDataToServer, paymentExists }) {

  /* ------------------------------------------------------------ STATE ------------------------------------------------------------ */

  const [value, setValue] = useState(normalizeSalesforceValue(questionInfo.idForm, questionInfo.value));

  const currentPeriod = data?.data?.[getNumberFiliereActif];
  const questionLookup = buildQuestionLookup(currentPeriod);
  const questions = data.data[getNumberFiliereActif].criteres[getNumberCritereActif].sousCriteres[sousCritereIndex].questions;
  const visible = isQuestionVisible(questionInfo, {
    dataFiltres: currentPeriod?.filtres,
    questionLookup
  });

  const listePredef = [

    //0 - Indicatifs téléphoniques (pays + code)
    [
      { "id": 0, "value": "France: +33", "text": "France: +33" },
      { "id": 1, "value": "Afghanistan: +93", "text": "Afghanistan: +93" },
      { "id": 2, "value": "Afrique du Sud: +27", "text": "Afrique du Sud: +27" },
      { "id": 3, "value": "Albanie: +355", "text": "Albanie: +355" },
      { "id": 4, "value": "Algérie: +213", "text": "Algérie: +213" },
      { "id": 5, "value": "Allemagne: +49", "text": "Allemagne: +49" },
      { "id": 6, "value": "Andorre: +376", "text": "Andorre: +376" },
      { "id": 7, "value": "Angola: +244", "text": "Angola: +244" },
      { "id": 8, "value": "Anguilla: +1 264", "text": "Anguilla: +1 264" },
      { "id": 9, "value": "Antarctique: +672", "text": "Antarctique: +672" },
      { "id": 10, "value": "Antigua-et-Barbuda: +1 268", "text": "Antigua-et-Barbuda: +1 268" },
      { "id": 11, "value": "Antilles néerlandaises: +599", "text": "Antilles néerlandaises: +599" },
      { "id": 12, "value": "Arabie Saoudite: +966", "text": "Arabie Saoudite: +966" },
      { "id": 13, "value": "Argentine: +54", "text": "Argentine: +54" },
      { "id": 14, "value": "Arménie: +374", "text": "Arménie: +374" },
      { "id": 15, "value": "Aruba: +297", "text": "Aruba: +297" },
      { "id": 16, "value": "Australie: +61", "text": "Australie: +61" },
      { "id": 17, "value": "Autriche: +43", "text": "Autriche: +43" },
      { "id": 18, "value": "Azerbaïdjan: +994", "text": "Azerbaïdjan: +994" },
      { "id": 19, "value": "Bahamas: +1 242", "text": "Bahamas: +1 242" },
      { "id": 20, "value": "Bahreïn: +973", "text": "Bahreïn: +973" },
      { "id": 21, "value": "Bangladesh: +880", "text": "Bangladesh: +880" },
      { "id": 22, "value": "Barbade: +1 246", "text": "Barbade: +1 246" },
      { "id": 23, "value": "Belgique: +32", "text": "Belgique: +32" },
      { "id": 24, "value": "Belize: +501", "text": "Belize: +501" },
      { "id": 25, "value": "Bénin: +229", "text": "Bénin: +229" },
      { "id": 26, "value": "Bermudes: +1 441", "text": "Bermudes: +1 441" },
      { "id": 27, "value": "Bhoutan: +975", "text": "Bhoutan: +975" },
      { "id": 28, "value": "Biélorussie: +375", "text": "Biélorussie: +375" },
      { "id": 29, "value": "Bolivie: +591", "text": "Bolivie: +591" },
      { "id": 30, "value": "Bosnie-Herzégovine: +387", "text": "Bosnie-Herzégovine: +387" },
      { "id": 31, "value": "Botswana: +267", "text": "Botswana: +267" },
      { "id": 32, "value": "Brésil: +55", "text": "Brésil: +55" },
      { "id": 33, "value": "Bulgarie: +359", "text": "Bulgarie: +359" },
      { "id": 34, "value": "Burkina Faso: +226", "text": "Burkina Faso: +226" },
      { "id": 35, "value": "Burundi: +257", "text": "Burundi: +257" },
      { "id": 36, "value": "Cambodge: +855", "text": "Cambodge: +855" },
      { "id": 37, "value": "Cameroun: +237", "text": "Cameroun: +237" },
      { "id": 38, "value": "Canada: +1", "text": "Canada: +1" },
      { "id": 39, "value": "Cap-Vert: +238", "text": "Cap-Vert: +238" },
      { "id": 40, "value": "Chili: +56", "text": "Chili: +56" },
      { "id": 41, "value": "Chine: +86", "text": "Chine: +86" },
      { "id": 42, "value": "Chypre: +357", "text": "Chypre: +357" },
      { "id": 43, "value": "Colombie: +57", "text": "Colombie: +57" },
      { "id": 44, "value": "Comores: +269", "text": "Comores: +269" },
      { "id": 45, "value": "Congo (République démocratique du): +243", "text": "Congo (République démocratique du): +243" },
      { "id": 46, "value": "Congo (République du): +242", "text": "Congo (République du): +242" },
      { "id": 47, "value": "Corée du Nord: +850", "text": "Corée du Nord: +850" },
      { "id": 48, "value": "Corée du Sud: +82", "text": "Corée du Sud: +82" },
      { "id": 49, "value": "Costa Rica: +506", "text": "Costa Rica: +506" },
      { "id": 50, "value": "Côte d'Ivoire: +225", "text": "Côte d'Ivoire: +225" },
      { "id": 51, "value": "Croatie: +385", "text": "Croatie: +385" },
      { "id": 52, "value": "Cuba: +53", "text": "Cuba: +53" },
      { "id": 53, "value": "Danemark: +45", "text": "Danemark: +45" },
      { "id": 54, "value": "Djibouti: +253", "text": "Djibouti: +253" },
      { "id": 55, "value": "Dominique: +1 767", "text": "Dominique: +1 767" },
      { "id": 56, "value": "Égypte: +20", "text": "Égypte: +20" },
      { "id": 57, "value": "El Salvador: +503", "text": "El Salvador: +503" },
      { "id": 58, "value": "Émirats arabes unis: +971", "text": "Émirats arabes unis: +971" },
      { "id": 59, "value": "Équateur: +593", "text": "Équateur: +593" },
      { "id": 60, "value": "Érythrée: +291", "text": "Érythrée: +291" },
      { "id": 61, "value": "Espagne: +34", "text": "Espagne: +34" },
      { "id": 62, "value": "Estonie: +372", "text": "Estonie: +372" },
      { "id": 63, "value": "États-Unis: +1", "text": "États-Unis: +1" },
      { "id": 64, "value": "Éthiopie: +251", "text": "Éthiopie: +251" },
      { "id": 65, "value": "Fidji: +679", "text": "Fidji: +679" },
      { "id": 66, "value": "Finlande: +358", "text": "Finlande: +358" },
      { "id": 68, "value": "Gabon: +241", "text": "Gabon: +241" },
      { "id": 69, "value": "Gambie: +220", "text": "Gambie: +220" },
      { "id": 70, "value": "Géorgie: +995", "text": "Géorgie: +995" },
      { "id": 71, "value": "Ghana: +233", "text": "Ghana: +233" },
      { "id": 72, "value": "Gibraltar: +350", "text": "Gibraltar: +350" },
      { "id": 73, "value": "Grèce: +30", "text": "Grèce: +30" },
      { "id": 74, "value": "Grenade: +1 473", "text": "Grenade: +1 473" },
      { "id": 75, "value": "Guadeloupe: +590", "text": "Guadeloupe: +590" },
      { "id": 76, "value": "Guam: +1 671", "text": "Guam: +1 671" },
      { "id": 77, "value": "Guatemala: +502", "text": "Guatemala: +502" },
      { "id": 78, "value": "Guinée: +224", "text": "Guinée: +224" },
      { "id": 79, "value": "Guinée-Bissau: +245", "text": "Guinée-Bissau: +245" },
      { "id": 80, "value": "Guinée équatoriale: +240", "text": "Guinée équatoriale: +240" },
      { "id": 81, "value": "Guyana: +592", "text": "Guyana: +592" },
      { "id": 82, "value": "Guyane française: +594", "text": "Guyane française: +594" },
      { "id": 83, "value": "Haïti: +509", "text": "Haïti: +509" },
      { "id": 84, "value": "Honduras: +504", "text": "Honduras: +504" },
      { "id": 85, "value": "Hong Kong: +852", "text": "Hong Kong: +852" },
      { "id": 86, "value": "Hongrie: +36", "text": "Hongrie: +36" },
      { "id": 87, "value": "Île Christmas: +61", "text": "Île Christmas: +61" },
      { "id": 88, "value": "Île Norfolk: +672", "text": "Île Norfolk: +672" },
      { "id": 89, "value": "Îles Caïmans: +1 345", "text": "Îles Caïmans: +1 345" },
      { "id": 90, "value": "Îles Cocos: +61", "text": "Îles Cocos: +61" },
      { "id": 91, "value": "Îles Cook: +682", "text": "Îles Cook: +682" },
      { "id": 92, "value": "Îles Falkland: +500", "text": "Îles Falkland: +500" },
      { "id": 93, "value": "Îles Féroé: +298", "text": "Îles Féroé: +298" },
      { "id": 94, "value": "Îles Marshall: +692", "text": "Îles Marshall: +692" },
      { "id": 95, "value": "Îles Salomon: +677", "text": "Îles Salomon: +677" },
      { "id": 96, "value": "Îles Turks et Caïques: +1 649", "text": "Îles Turks et Caïques: +1 649" },
      { "id": 97, "value": "Îles Vierges britanniques: +1 284", "text": "Îles Vierges britanniques: +1 284" },
      { "id": 98, "value": "Îles Vierges des États-Unis: +1 340", "text": "Îles Vierges des États-Unis: +1 340" },
      { "id": 99, "value": "Inde: +91", "text": "Inde: +91" },
      { "id": 100, "value": "Indonésie: +62", "text": "Indonésie: +62" },
      { "id": 101, "value": "Irak: +964", "text": "Irak: +964" },
      { "id": 102, "value": "Iran: +98", "text": "Iran: +98" },
      { "id": 103, "value": "Irlande: +353", "text": "Irlande: +353" },
      { "id": 104, "value": "Islande: +354", "text": "Islande: +354" },
      { "id": 105, "value": "Israël: +972", "text": "Israël: +972" },
      { "id": 106, "value": "Italie: +39", "text": "Italie: +39" },
      { "id": 107, "value": "Jamaïque: +1 876", "text": "Jamaïque: +1 876" },
      { "id": 108, "value": "Japon: +81", "text": "Japon: +81" },
      { "id": 109, "value": "Jordanie: +962", "text": "Jordanie: +962" },
      { "id": 110, "value": "Kazakhstan: +7", "text": "Kazakhstan: +7" },
      { "id": 111, "value": "Kenya: +254", "text": "Kenya: +254" },
      { "id": 112, "value": "Kirghizistan: +996", "text": "Kirghizistan: +996" },
      { "id": 113, "value": "Kiribati: +686", "text": "Kiribati: +686" },
      { "id": 114, "value": "Koweït: +965", "text": "Koweït: +965" },
      { "id": 115, "value": "Laos: +856", "text": "Laos: +856" },
      { "id": 116, "value": "Lesotho: +266", "text": "Lesotho: +266" },
      { "id": 117, "value": "Lettonie: +371", "text": "Lettonie: +371" },
      { "id": 118, "value": "Liban: +961", "text": "Liban: +961" },
      { "id": 119, "value": "Liberia: +231", "text": "Liberia: +231" },
      { "id": 120, "value": "Libye: +218", "text": "Libye: +218" },
      { "id": 121, "value": "Liechtenstein: +423", "text": "Liechtenstein: +423" },
      { "id": 122, "value": "Lituanie: +370", "text": "Lituanie: +370" },
      { "id": 123, "value": "Luxembourg: +352", "text": "Luxembourg: +352" },
      { "id": 124, "value": "Macao: +853", "text": "Macao: +853" },
      { "id": 125, "value": "Macédoine: +389", "text": "Macédoine: +389" },
      { "id": 126, "value": "Madagascar: +261", "text": "Madagascar: +261" },
      { "id": 127, "value": "Malaisie: +60", "text": "Malaisie: +60" },
      { "id": 128, "value": "Malawi: +265", "text": "Malawi: +265" },
      { "id": 129, "value": "Maldives: +960", "text": "Maldives: +960" },
      { "id": 130, "value": "Mali: +223", "text": "Mali: +223" },
      { "id": 131, "value": "Malte: +356", "text": "Malte: +356" },
      { "id": 132, "value": "Maroc: +212", "text": "Maroc: +212" },
      { "id": 133, "value": "Martinique: +596", "text": "Martinique: +596" },
      { "id": 134, "value": "Maurice: +230", "text": "Maurice: +230" },
      { "id": 135, "value": "Mauritanie: +222", "text": "Mauritanie: +222" },
      { "id": 136, "value": "Mayotte: +262", "text": "Mayotte: +262" },
      { "id": 137, "value": "Mexique: +52", "text": "Mexique: +52" },
      { "id": 138, "value": "Micronésie: +691", "text": "Micronésie: +691" },
      { "id": 139, "value": "Moldavie: +373", "text": "Moldavie: +373" },
      { "id": 140, "value": "Monaco: +377", "text": "Monaco: +377" },
      { "id": 141, "value": "Mongolie: +976", "text": "Mongolie: +976" },
      { "id": 142, "value": "Monténégro: +382", "text": "Monténégro: +382" },
      { "id": 143, "value": "Montserrat: +1 664", "text": "Montserrat: +1 664" },
      { "id": 144, "value": "Mozambique: +258", "text": "Mozambique: +258" },
      { "id": 145, "value": "Myanmar: +95", "text": "Myanmar: +95" },
      { "id": 146, "value": "Namibie: +264", "text": "Namibie: +264" },
      { "id": 147, "value": "Nauru: +674", "text": "Nauru: +674" },
      { "id": 148, "value": "Népal: +977", "text": "Népal: +977" },
      { "id": 149, "value": "Nicaragua: +505", "text": "Nicaragua: +505" },
      { "id": 150, "value": "Niger: +227", "text": "Niger: +227" },
      { "id": 151, "value": "Nigeria: +234", "text": "Nigeria: +234" },
      { "id": 152, "value": "Niue: +683", "text": "Niue: +683" },
      { "id": 153, "value": "Norvège: +47", "text": "Norvège: +47" },
      { "id": 154, "value": "Nouvelle-Calédonie: +687", "text": "Nouvelle-Calédonie: +687" },
      { "id": 155, "value": "Nouvelle-Zélande: +64", "text": "Nouvelle-Zélande: +64" },
      { "id": 156, "value": "Oman: +968", "text": "Oman: +968" },
      { "id": 157, "value": "Ouganda: +256", "text": "Ouganda: +256" },
      { "id": 158, "value": "Ouzbékistan: +998", "text": "Ouzbékistan: +998" },
      { "id": 159, "value": "Pakistan: +92", "text": "Pakistan: +92" },
      { "id": 160, "value": "Palau: +680", "text": "Palau: +680" },
      { "id": 161, "value": "Palestine: +970", "text": "Palestine: +970" },
      { "id": 162, "value": "Panama: +507", "text": "Panama: +507" },
      { "id": 163, "value": "Papouasie-Nouvelle-Guinée: +675", "text": "Papouasie-Nouvelle-Guinée: +675" },
      { "id": 164, "value": "Paraguay: +595", "text": "Paraguay: +595" },
      { "id": 165, "value": "Pays-Bas: +31", "text": "Pays-Bas: +31" },
      { "id": 166, "value": "Pérou: +51", "text": "Pérou: +51" },
      { "id": 167, "value": "Philippines: +63", "text": "Philippines: +63" },
      { "id": 168, "value": "Pitcairn: +64", "text": "Pitcairn: +64" },
      { "id": 169, "value": "Pologne: +48", "text": "Pologne: +48" },
      { "id": 170, "value": "Polynésie française: +689", "text": "Polynésie française: +689" },
      { "id": 171, "value": "Portugal: +351", "text": "Portugal: +351" },
      { "id": 172, "value": "Puerto Rico: +1 787, +1 939", "text": "Puerto Rico: +1 787, +1 939" },
      { "id": 173, "value": "Qatar: +974", "text": "Qatar: +974" },
      { "id": 174, "value": "République centrafricaine: +236", "text": "République centrafricaine: +236" },
      { "id": 175, "value": "République dominicaine: +1 809, +1 829, +1 849", "text": "République dominicaine: +1 809, +1 829, +1 849" },
      { "id": 176, "value": "République tchèque: +420", "text": "République tchèque: +420" },
      { "id": 177, "value": "Réunion: +262", "text": "Réunion: +262" },
      { "id": 178, "value": "Roumanie: +40", "text": "Roumanie: +40" },
      { "id": 179, "value": "Royaume-Uni: +44", "text": "Royaume-Uni: +44" },
      { "id": 180, "value": "Russie: +7", "text": "Russie: +7" },
      { "id": 181, "value": "Rwanda: +250", "text": "Rwanda: +250" },
      { "id": 182, "value": "Sahara occidental: +212", "text": "Sahara occidental: +212" },
      { "id": 183, "value": "Sainte-Hélène: +290", "text": "Sainte-Hélène: +290" },
      { "id": 184, "value": "Sainte-Lucie: +1 758", "text": "Sainte-Lucie: +1 758" },
      { "id": 185, "value": "Saint-Kitts-et-Nevis: +1 869", "text": "Saint-Kitts-et-Nevis: +1 869" },
      { "id": 186, "value": "Saint-Marin: +378", "text": "Saint-Marin: +378" },
      { "id": 187, "value": "Saint-Vincent-et-les-Grenadines: +1 784", "text": "Saint-Vincent-et-les-Grenadines: +1 784" },
      { "id": 188, "value": "Salomon: +677", "text": "Salomon: +677" },
      { "id": 189, "value": "Samoa: +685", "text": "Samoa: +685" },
      { "id": 190, "value": "Samoa américaines: +1 684", "text": "Samoa américaines: +1 684" },
      { "id": 191, "value": "Sao Tomé-et-Principe: +239", "text": "Sao Tomé-et-Principe: +239" },
      { "id": 192, "value": "Sénégal: +221", "text": "Sénégal: +221" },
      { "id": 193, "value": "Serbie: +381", "text": "Serbie: +381" },
      { "id": 194, "value": "Seychelles: +248", "text": "Seychelles: +248" },
      { "id": 195, "value": "Sierra Leone: +232", "text": "Sierra Leone: +232" },
      { "id": 196, "value": "Singapour: +65", "text": "Singapour: +65" },
      { "id": 197, "value": "Slovaquie: +421", "text": "Slovaquie: +421" },
      { "id": 198, "value": "Slovénie: +386", "text": "Slovénie: +386" },
      { "id": 199, "value": "Somalie: +252", "text": "Somalie: +252" },
      { "id": 200, "value": "Soudan: +249", "text": "Soudan: +249" },
      { "id": 201, "value": "Sri Lanka: +94", "text": "Sri Lanka: +94" },
      { "id": 202, "value": "Suède: +46", "text": "Suède: +46" },
      { "id": 203, "value": "Suisse: +41", "text": "Suisse: +41" },
      { "id": 204, "value": "Suriname: +597", "text": "Suriname: +597" },
      { "id": 205, "value": "Syrie: +963", "text": "Syrie: +963" },
      { "id": 206, "value": "Tadjikistan: +992", "text": "Tadjikistan: +992" },
      { "id": 207, "value": "Taiwan: +886", "text": "Taiwan: +886" },
      { "id": 208, "value": "Tanzanie: +255", "text": "Tanzanie: +255" },
      { "id": 209, "value": "Tchad: +235", "text": "Tchad: +235" },
      { "id": 210, "value": "Thaïlande: +66", "text": "Thaïlande: +66" },
      { "id": 211, "value": "Timor-Leste: +670", "text": "Timor-Leste: +670" },
      { "id": 212, "value": "Togo: +228", "text": "Togo: +228" },
      { "id": 213, "value": "Tokelau: +690", "text": "Tokelau: +690" },
      { "id": 214, "value": "Tonga: +676", "text": "Tonga: +676" },
      { "id": 215, "value": "Trinité-et-Tobago: +1 868", "text": "Trinité-et-Tobago: +1 868" },
      { "id": 216, "value": "Tunisie: +216", "text": "Tunisie: +216" },
      { "id": 217, "value": "Turkménistan: +993", "text": "Turkménistan: +993" },
      { "id": 218, "value": "Turquie: +90", "text": "Turquie: +90" },
      { "id": 219, "value": "Tuvalu: +688", "text": "Tuvalu: +688" },
      { "id": 220, "value": "Ukraine: +380", "text": "Ukraine: +380" },
      { "id": 221, "value": "Uruguay: +598", "text": "Uruguay: +598" },
      { "id": 222, "value": "Vanuatu: +678", "text": "Vanuatu: +678" },
      { "id": 223, "value": "Vatican: +379", "text": "Vatican: +379" },
      { "id": 224, "value": "Venezuela: +58", "text": "Venezuela: +58" },
      { "id": 225, "value": "Viêt Nam: +84", "text": "Viêt Nam: +84" },
      { "id": 226, "value": "Wallis-et-Futuna: +681", "text": "Wallis-et-Futuna: +681" },
      { "id": 227, "value": "Yémen: +967", "text": "Yémen: +967" },
      { "id": 228, "value": "Zambie: +260", "text": "Zambie: +260" },
      { "id": 229, "value": "Zimbabwe: +263", "text": "Zimbabwe: +263" }
    ],
    //1 - Nationalités (démonyms)
    [
      {
        "id": 1,
        "value": "Française",
        "text": "Française"
      },
      {
        "id": 2,
        "value": "Afghane",
        "text": "Afghane"
      },
      {
        "id": 3,
        "value": "Albanaise",
        "text": "Albanaise"
      },
      {
        "id": 4,
        "value": "Algérienne",
        "text": "Algérienne"
      },
      {
        "id": 5,
        "value": "Allemande",
        "text": "Allemande"
      },
      {
        "id": 6,
        "value": "Andorrane",
        "text": "Andorrane"
      },
      {
        "id": 7,
        "value": "Angolaise",
        "text": "Angolaise"
      },
      {
        "id": 8,
        "value": "Antiguayenne",
        "text": "Antiguayenne"
      },
      {
        "id": 9,
        "value": "Argentine",
        "text": "Argentine"
      },
      {
        "id": 10,
        "value": "Arménienne",
        "text": "Arménienne"
      },
      {
        "id": 11,
        "value": "Américaine",
        "text": "Américaine"
      },
      {
        "id": 12,
        "value": "Arubainne",
        "text": "Arubainne"
      },
      {
        "id": 13,
        "value": "Australienne",
        "text": "Australienne"
      },
      {
        "id": 14,
        "value": "Autrichienne",
        "text": "Autrichienne"
      },
      {
        "id": 15,
        "value": "Azerbaïdjanaise",
        "text": "Azerbaïdjanaise"
      },
      {
        "id": 16,
        "value": "Bahamienne",
        "text": "Bahamienne"
      },
      {
        "id": 17,
        "value": "Bahreïnienne",
        "text": "Bahreïnienne"
      },
      {
        "id": 18,
        "value": "Bangladaise, Bangladeshie",
        "text": "Bangladaise, Bangladeshie"
      },
      {
        "id": 19,
        "value": "Barbadienne",
        "text": "Barbadienne"
      },
      {
        "id": 20,
        "value": "Belge",
        "text": "Belge"
      },
      {
        "id": 21,
        "value": "Bélizienne",
        "text": "Bélizienne"
      },
      {
        "id": 22,
        "value": "Béninoise",
        "text": "Béninoise"
      },
      {
        "id": 23,
        "value": "Bermudienne",
        "text": "Bermudienne"
      },
      {
        "id": 24,
        "value": "Bhoutanaise",
        "text": "Bhoutanaise"
      },
      {
        "id": 25,
        "value": "Biélorusse",
        "text": "Biélorusse"
      },
      {
        "id": 26,
        "value": "Birmane",
        "text": "Birmane"
      },
      {
        "id": 27,
        "value": "Bissau-Guinéenne",
        "text": "Bissau-Guinéenne"
      },
      {
        "id": 28,
        "value": "Bolivienne",
        "text": "Bolivienne"
      },
      {
        "id": 29,
        "value": "Bosniaque, Bosnienne",
        "text": "Bosniaque, Bosnienne"
      },
      {
        "id": 30,
        "value": "Botswanaise, Botswanéenne",
        "text": "Botswanaise, Botswanéenne"
      },
      {
        "id": 31,
        "value": "Brésilienne",
        "text": "Brésilienne"
      },
      {
        "id": 32,
        "value": "Britannique",
        "text": "Britannique"
      },
      {
        "id": 33,
        "value": "Brunéienne",
        "text": "Brunéienne"
      },
      {
        "id": 34,
        "value": "Bulgare",
        "text": "Bulgare"
      },
      {
        "id": 35,
        "value": "Burkinabée, Burkinaise",
        "text": "Burkinabée, Burkinaise"
      },
      {
        "id": 36,
        "value": "Burundaise",
        "text": "Burundaise"
      },
      {
        "id": 37,
        "value": "Cambodgienne",
        "text": "Cambodgienne"
      },
      {
        "id": 38,
        "value": "Camerounaise",
        "text": "Camerounaise"
      },
      {
        "id": 39,
        "value": "Centrafricaine",
        "text": "Centrafricaine"
      },
      {
        "id": 40,
        "value": "Chilienne",
        "text": "Chilienne"
      },
      {
        "id": 41,
        "value": "Chinoise",
        "text": "Chinoise"
      },
      {
        "id": 42,
        "value": "Christophien",
        "text": "Christophien"
      },
      {
        "id": 43,
        "value": "Chypriote, Cypriote",
        "text": "Chypriote, Cypriote"
      },
      {
        "id": 44,
        "value": "Colombienne",
        "text": "Colombienne"
      },
      {
        "id": 45,
        "value": "Comorienne",
        "text": "Comorienne"
      },
      {
        "id": 46,
        "value": "Congolaise",
        "text": "Congolaise"
      },
      {
        "id": 47,
        "value": "Congolaise (République Démocratique du Congo)",
        "text": "Congolaise (République Démocratique du Congo)"
      },
      {
        "id": 48,
        "value": "Costaricaine, Costaricienne",
        "text": "Costaricaine, Costaricienne"
      },
      {
        "id": 49,
        "value": "Croate",
        "text": "Croate"
      },
      {
        "id": 50,
        "value": "Cubaine",
        "text": "Cubaine"
      },
      {
        "id": 51,
        "value": "Danoise",
        "text": "Danoise"
      },
      {
        "id": 52,
        "value": "Djiboutienne",
        "text": "Djiboutienne"
      },
      {
        "id": 53,
        "value": "Dominiquaise",
        "text": "Dominiquaise"
      },
      {
        "id": 54,
        "value": "Dominicaine",
        "text": "Dominicaine"
      },
      {
        "id": 55,
        "value": "Égyptienne",
        "text": "Égyptienne"
      },
      {
        "id": 56,
        "value": "Émirienne",
        "text": "Émirienne"
      },
      {
        "id": 57,
        "value": "Équatorienne",
        "text": "Équatorienne"
      },
      {
        "id": 58,
        "value": "Espagnole",
        "text": "Espagnole"
      },
      {
        "id": 59,
        "value": "Est-Timoraise",
        "text": "Est-Timoraise"
      },
      {
        "id": 60,
        "value": "Équato-Guinéenne",
        "text": "Équato-Guinéenne"
      },
      {
        "id": 61,
        "value": "Érythréenne",
        "text": "Érythréenne"
      },
      {
        "id": 62,
        "value": "Estonienne",
        "text": "Estonienne"
      },
      {
        "id": 63,
        "value": "Éthiopienne",
        "text": "Éthiopienne"
      },
      {
        "id": 64,
        "value": "Fidjienne",
        "text": "Fidjienne"
      },
      {
        "id": 65,
        "value": "Finlandaise",
        "text": "Finlandaise"
      },
      {
        "id": 66,
        "value": "Gabonaise",
        "text": "Gabonaise"
      },
      {
        "id": 67,
        "value": "Gambienne",
        "text": "Gambienne"
      },
      {
        "id": 68,
        "value": "Géorgienne",
        "text": "Géorgienne"
      },
      {
        "id": 69,
        "value": "Ghanéenne",
        "text": "Ghanéenne"
      },
      {
        "id": 70,
        "value": "Grec - Grecque",
        "text": "Grec - Grecque"
      },
      {
        "id": 71,
        "value": "Grenadienne",
        "text": "Grenadienne"
      },
      {
        "id": 72,
        "value": "Guatémaltèque",
        "text": "Guatémaltèque"
      },
      {
        "id": 73,
        "value": "Guernesiaise",
        "text": "Guernesiaise"
      },
      {
        "id": 74,
        "value": "Guinéenne",
        "text": "Guinéenne"
      },
      {
        "id": 75,
        "value": "Guyanaise, Guyanienne",
        "text": "Guyanaise, Guyanienne"
      },
      {
        "id": 76,
        "value": "Haïtienne",
        "text": "Haïtienne"
      },
      {
        "id": 77,
        "value": "Hondurienne",
        "text": "Hondurienne"
      },
      {
        "id": 78,
        "value": "Hongroise",
        "text": "Hongroise"
      },
      {
        "id": 79,
        "value": "Islandaise",
        "text": "Islandaise"
      },
      {
        "id": 80,
        "value": "Indienne",
        "text": "Indienne"
      },
      {
        "id": 81,
        "value": "Indonésienne",
        "text": "Indonésienne"
      },
      {
        "id": 82,
        "value": "Iranienne",
        "text": "Iranienne"
      },
      {
        "id": 83,
        "value": "Irakienne, Iraquienne",
        "text": "Irakienne, Iraquienne"
      },
      {
        "id": 84,
        "value": "Irlandaise",
        "text": "Irlandaise"
      },
      {
        "id": 85,
        "value": "Israélienne",
        "text": "Israélienne"
      },
      {
        "id": 86,
        "value": "Italienne",
        "text": "Italienne"
      },
      {
        "id": 87,
        "value": "Ivoirienne",
        "text": "Ivoirienne"
      },
      {
        "id": 88,
        "value": "Jamaïcaine",
        "text": "Jamaïcaine"
      },
      {
        "id": 89,
        "value": "Japonaise",
        "text": "Japonaise"
      },
      {
        "id": 90,
        "value": "Jordanienne",
        "text": "Jordanienne"
      },
      {
        "id": 91,
        "value": "Kazakhe",
        "text": "Kazakhe"
      },
      {
        "id": 92,
        "value": "Kenyane",
        "text": "Kenyane"
      },
      {
        "id": 93,
        "value": "Kirghiz",
        "text": "Kirghiz"
      },
      {
        "id": 94,
        "value": "Kiribatienne",
        "text": "Kiribatienne"
      },
      {
        "id": 95,
        "value": "Koweïtienne",
        "text": "Koweïtienne"
      },
      {
        "id": 96,
        "value": "Laotienne",
        "text": "Laotienne"
      },
      {
        "id": 97,
        "value": "Lettonne",
        "text": "Lettonne"
      },
      {
        "id": 98,
        "value": "Libanaise",
        "text": "Libanaise"
      },
      {
        "id": 99,
        "value": "Lesothane",
        "text": "Lesothane"
      },
      {
        "id": 100,
        "value": "Libérienne",
        "text": "Libérienne"
      },
      {
        "id": 101,
        "value": "Libyenne",
        "text": "Libyenne"
      },
      {
        "id": 102,
        "value": "Liechtensteinoise",
        "text": "Liechtensteinoise"
      },
      {
        "id": 103,
        "value": "Lituanienne",
        "text": "Lituanienne"
      },
      {
        "id": 104,
        "value": "Lucien, Saint-Lucien",
        "text": "Lucien, Saint-Lucien"
      },
      {
        "id": 105,
        "value": "Luxembourgeoise",
        "text": "Luxembourgeoise"
      },
      {
        "id": 106,
        "value": "Macédonienne",
        "text": "Macédonienne"
      },
      {
        "id": 107,
        "value": "Malawite, Malawienne",
        "text": "Malawite, Malawienne"
      },
      {
        "id": 108,
        "value": "Malaisienne",
        "text": "Malaisienne"
      },
      {
        "id": 109,
        "value": "Malienne",
        "text": "Malienne"
      },
      {
        "id": 110,
        "value": "Maltaise",
        "text": "Maltaise"
      },
      {
        "id": 111,
        "value": "Marocaine",
        "text": "Marocaine"
      },
      {
        "id": 112,
        "value": "Marshallaise",
        "text": "Marshallaise"
      },
      {
        "id": 113,
        "value": "Mauritanienne",
        "text": "Mauritanienne"
      },
      {
        "id": 114,
        "value": "Mauricienne",
        "text": "Mauricienne"
      },
      {
        "id": 115,
        "value": "Mexicaine",
        "text": "Mexicaine"
      },
      {
        "id": 116,
        "value": "Moldave",
        "text": "Moldave"
      },
      {
        "id": 117,
        "value": "Monégasque",
        "text": "Monégasque"
      },
      {
        "id": 118,
        "value": "Mongole",
        "text": "Mongole"
      },
      {
        "id": 119,
        "value": "Monténégrine",
        "text": "Monténégrine"
      },
      {
        "id": 120,
        "value": "Mozambicaine",
        "text": "Mozambicaine"
      },
      {
        "id": 121,
        "value": "Namibienne",
        "text": "Namibienne"
      },
      {
        "id": 122,
        "value": "Nauruans",
        "text": "Nauruans"
      },
      {
        "id": 123,
        "value": "Népalaise",
        "text": "Népalaise"
      },
      {
        "id": 124,
        "value": "Néerlandaise",
        "text": "Néerlandaise"
      },
      {
        "id": 125,
        "value": "Néo-Zélandaise",
        "text": "Néo-Zélandaise"
      },
      {
        "id": 126,
        "value": "Nicaraguayenne",
        "text": "Nicaraguayenne"
      },
      {
        "id": 127,
        "value": "Nigérienne",
        "text": "Nigérienne"
      },
      {
        "id": 128,
        "value": "Nigériane",
        "text": "Nigériane"
      },
      {
        "id": 129,
        "value": "Niue",
        "text": "Niue"
      },
      {
        "id": 130,
        "value": "Nord-Coréenne",
        "text": "Nord-Coréenne"
      },
      {
        "id": 131,
        "value": "Norvégienne",
        "text": "Norvégienne"
      },
      {
        "id": 132,
        "value": "Omanaise",
        "text": "Omanaise"
      },
      {
        "id": 133,
        "value": "Pakistanaise",
        "text": "Pakistanaise"
      },
      {
        "id": 134,
        "value": "Palaois, Paluan",
        "text": "Palaois, Paluan"
      },
      {
        "id": 135,
        "value": "Panaméenne",
        "text": "Panaméenne"
      },
      {
        "id": 136,
        "value": "Papouasienne",
        "text": "Papouasienne"
      },
      {
        "id": 137,
        "value": "Paraguayenne",
        "text": "Paraguayenne"
      },
      {
        "id": 138,
        "value": "Péruvienne",
        "text": "Péruvienne"
      },
      {
        "id": 139,
        "value": "Philippine",
        "text": "Philippine"
      },
      {
        "id": 140,
        "value": "Polonaise",
        "text": "Polonaise"
      },
      {
        "id": 141,
        "value": "Portugaise",
        "text": "Portugaise"
      },
      {
        "id": 142,
        "value": "Qatarie, Qatarienne",
        "text": "Qatarie, Qatarienne"
      },
      {
        "id": 143,
        "value": "Roumaine",
        "text": "Roumaine"
      },
      {
        "id": 144,
        "value": "Russe",
        "text": "Russe"
      },
      {
        "id": 145,
        "value": "Rwandaise",
        "text": "Rwandaise"
      },
      {
        "id": 146,
        "value": "Saint-Marinais",
        "text": "Saint-Marinais"
      },
      {
        "id": 147,
        "value": "Saint-Vincentaise, Grenadine",
        "text": "Saint-Vincentaise, Grenadine"
      },
      {
        "id": 148,
        "value": "Salomonienne, Salomonaise",
        "text": "Salomonienne, Salomonaise"
      },
      {
        "id": 149,
        "value": "Salvadorienne",
        "text": "Salvadorienne"
      },
      {
        "id": 150,
        "value": "Samoans",
        "text": "Samoans"
      },
      {
        "id": 151,
        "value": "Santoméenne",
        "text": "Santoméenne"
      },
      {
        "id": 152,
        "value": "Saoudienne",
        "text": "Saoudienne"
      },
      {
        "id": 153,
        "value": "Sénégalaise",
        "text": "Sénégalaise"
      },
      {
        "id": 154,
        "value": "Serbe",
        "text": "Serbe"
      },
      {
        "id": 155,
        "value": "Seychellois",
        "text": "Seychellois"
      },
      {
        "id": 156,
        "value": "Sierra-Léonaise",
        "text": "Sierra-Léonaise"
      },
      {
        "id": 157,
        "value": "Singapourienne",
        "text": "Singapourienne"
      },
      {
        "id": 158,
        "value": "Slovaque",
        "text": "Slovaque"
      },
      {
        "id": 159,
        "value": "Slovène",
        "text": "Slovène"
      },
      {
        "id": 160,
        "value": "Somalienne",
        "text": "Somalienne"
      },
      {
        "id": 161,
        "value": "Sud-Africaine",
        "text": "Sud-Africaine"
      },
      {
        "id": 162,
        "value": "Sud-Soudanaise",
        "text": "Sud-Soudanaise"
      },
      {
        "id": 163,
        "value": "Sud-Coréenne",
        "text": "Sud-Coréenne"
      },
      {
        "id": 164,
        "value": "Sri-Lankaise",
        "text": "Sri-Lankaise"
      },
      {
        "id": 165,
        "value": "Soudanaise",
        "text": "Soudanaise"
      },
      {
        "id": 166,
        "value": "Surinamienne",
        "text": "Surinamienne"
      },
      {
        "id": 167,
        "value": "Swazie",
        "text": "Swazie"
      },
      {
        "id": 168,
        "value": "Suédoise",
        "text": "Suédoise"
      },
      {
        "id": 169,
        "value": "Suisse",
        "text": "Suisse"
      },
      {
        "id": 170,
        "value": "Syrienne",
        "text": "Syrienne"
      },
      {
        "id": 171,
        "value": "Tadjik",
        "text": "Tadjik"
      },
      {
        "id": 172,
        "value": "Taiwanaise",
        "text": "Taiwanaise"
      },
      {
        "id": 173,
        "value": "Tanzanienne",
        "text": "Tanzanienne"
      },
      {
        "id": 174,
        "value": "Tchadienne",
        "text": "Tchadienne"
      },
      {
        "id": 175,
        "value": "Tchèque",
        "text": "Tchèque"
      },
      {
        "id": 176,
        "value": "Thaïlandaise",
        "text": "Thaïlandaise"
      },
      {
        "id": 177,
        "value": "Togolaise",
        "text": "Togolaise"
      },
      {
        "id": 178,
        "value": "Tongienne",
        "text": "Tongienne"
      },
      {
        "id": 179,
        "value": "Trinidadienne",
        "text": "Trinidadienne"
      },
      {
        "id": 180,
        "value": "Tunisienne",
        "text": "Tunisienne"
      },
      {
        "id": 181,
        "value": "Turc - Turque",
        "text": "Turc - Turque"
      },
      {
        "id": 182,
        "value": "Turkmène",
        "text": "Turkmène"
      },
      {
        "id": 183,
        "value": "Tuvaluane",
        "text": "Tuvaluane"
      },
      {
        "id": 184,
        "value": "Ukrainienne",
        "text": "Ukrainienne"
      },
      {
        "id": 185,
        "value": "Uruguayenne",
        "text": "Uruguayenne"
      },
      {
        "id": 186,
        "value": "Ougandaise",
        "text": "Ougandaise"
      },
      {
        "id": 187,
        "value": "Ouzbek",
        "text": "Ouzbek"
      },
      {
        "id": 188,
        "value": "Vanuataise",
        "text": "Vanuataise"
      },
      {
        "id": 189,
        "value": "Vénézuélienne",
        "text": "Vénézuélienne"
      },
      {
        "id": 190,
        "value": "Vietnamienne",
        "text": "Vietnamienne"
      },
      {
        "id": 191,
        "value": "Yéménite",
        "text": "Yéménite"
      },
      {
        "id": 192,
        "value": "Zambienne",
        "text": "Zambienne"
      },
      {
        "id": 193,
        "value": "Zimbabwéenne",
        "text": "Zimbabwéenne"
      },
      {
        "id": 194,
        "value": "Autre",
        "text": "Autre"
      },
      {
        "id": 195,
        "value": "Malgache",
        "text": "Malgache"
      },
      {
        "id": 196,
        "value": "Canadienne",
        "text": "Canadienne"
      }
    ],
    //2 - Pays (libellé + code ISO numérique)
    [
      { "id": 1, "value": "La France", "text": "France", "code": "250" },
      { "id": 2, "value": "L'Afghanistan", "text": "Afghanistan", "code": "004" },
      { "id": 3, "value": "L'Afrique du Sud", "text": "Afrique du Sud", "code": "710" },
      { "id": 4, "value": "L'Albanie", "text": "Albanie", "code": "008" },
      { "id": 5, "value": "L'Algérie", "text": "Algérie", "code": "012" },
      { "id": 6, "value": "L'Allemagne", "text": "Allemagne", "code": "276" },
      { "id": 7, "value": "L'Andorre", "text": "Andorre", "code": "020" },
      { "id": 8, "value": "L'Angola", "text": "Angola", "code": "024" },
      { "id": 9, "value": "L'Antigua-et-Barbuda", "text": "Antigua-et-Barbuda", "code": "028" },
      { "id": 10, "value": "L'Arabie Saoudite", "text": "Arabie Saoudite", "code": "682" },
      { "id": 11, "value": "L'Argentine", "text": "Argentine", "code": "032" },
      { "id": 12, "value": "L'Arménie", "text": "Arménie", "code": "051" },
      { "id": 13, "value": "Aruba", "text": "Aruba", "code": "533" },
      { "id": 14, "value": "L'Australie", "text": "Australie", "code": "036" },
      { "id": 15, "value": "L'Autriche", "text": "Autriche", "code": "040" },
      { "id": 16, "value": "L'Azerbaïdjan", "text": "Azerbaïdjan", "code": "031" },
      { "id": 17, "value": "Les Bahamas", "text": "Bahamas", "code": "044" },
      { "id": 18, "value": "Bahreïn", "text": "Bahreïn", "code": "048" },
      { "id": 19, "value": "Le Bangladesh", "text": "Bangladesh", "code": "050" },
      { "id": 20, "value": "La Barbade", "text": "Barbade", "code": "052" },
      { "id": 21, "value": "La Biélorussie / Le Bélarus", "text": "Biélorussie / Bélarus", "code": "112" },
      { "id": 22, "value": "La Birmanie", "text": "Birmanie", "code": "104" },
      { "id": 23, "value": "La Belgique", "text": "Belgique", "code": "056" },
      { "id": 24, "value": "Le Belize", "text": "Belize", "code": "084" },
      { "id": 25, "value": "Le Bénin", "text": "Bénin", "code": "204" },
      { "id": 26, "value": "Les Bermudes", "text": "Bermudes", "code": "060" },
      { "id": 27, "value": "Le Bhoutan", "text": "Bhoutan", "code": "064" },
      { "id": 28, "value": "La Bolivie", "text": "Bolivie", "code": "068" },
      { "id": 29, "value": "La Bosnie-Herzégovine", "text": "Bosnie-Herzégovine", "code": "070" },
      { "id": 30, "value": "Le Botswana", "text": "Botswana", "code": "072" },
      { "id": 31, "value": "Le Brésil", "text": "Brésil", "code": "076" },
      { "id": 32, "value": "Le Brunéi", "text": "Brunéi", "code": "096" },
      { "id": 33, "value": "La Bulgarie", "text": "Bulgarie", "code": "100" },
      { "id": 34, "value": "Le Burkina Faso", "text": "Burkina Faso", "code": "854" },
      { "id": 35, "value": "Le Burundi", "text": "Burundi", "code": "108" },
      { "id": 36, "value": "Le Cambodge", "text": "Cambodge", "code": "116" },
      { "id": 37, "value": "Le Cameroun", "text": "Cameroun", "code": "120" },
      { "id": 38, "value": "Le Canada", "text": "Canada", "code": "124" },
      { "id": 39, "value": "Le Cap-Vert", "text": "Cap-Vert", "code": "132" },
      { "id": 40, "value": "La Rép. centrafricaine", "text": "Rép. centrafricaine", "code": "140" },
      { "id": 41, "value": "Le Chili", "text": "Chili", "code": "152" },
      { "id": 42, "value": "La Chine", "text": "Chine", "code": "156" },
      { "id": 43, "value": "Chypre", "text": "Chypre", "code": "196" },
      { "id": 44, "value": "La Colombie", "text": "Colombie", "code": "170" },
      { "id": 45, "value": "Les Comores", "text": "Comores", "code": "174" },
      { "id": 46, "value": "La Rép. du Congo", "text": "Rép. du Congo", "code": "178" },
      { "id": 47, "value": "La Rép. dém. du Congo", "text": "Rép. dém. du Congo", "code": "180" },
      { "id": 48, "value": "La Corée du Nord", "text": "Corée du Nord", "code": "408" },
      { "id": 49, "value": "La Corée du Sud", "text": "Corée du Sud", "code": "410" },
      { "id": 50, "value": "Le Costa Rica", "text": "Costa Rica", "code": "188" },
      { "id": 51, "value": "La Côte d’Ivoire", "text": "Côte d’Ivoire", "code": "384" },
      { "id": 52, "value": "La Croatie", "text": "Croatie", "code": "191" },
      { "id": 53, "value": "Cuba", "text": "Cuba", "code": "192" },
      { "id": 54, "value": "Le Danemark", "text": "Danemark", "code": "208" },
      { "id": 55, "value": "La Dominique", "text": "Dominique", "code": "212" },
      { "id": 56, "value": "Djibouti", "text": "Djibouti", "code": "262" },
      { "id": 57, "value": "L'Égypte", "text": "Égypte", "code": "818" },
      { "id": 58, "value": "Les Émirats arabes unis", "text": "Émirats arabes unis", "code": "784" },
      { "id": 59, "value": "L'Équateur", "text": "Équateur", "code": "218" },
      { "id": 60, "value": "L'Érythrée", "text": "Érythrée", "code": "232" },
      { "id": 61, "value": "L'Espagne", "text": "Espagne", "code": "724" },
      { "id": 62, "value": "L'Estonie", "text": "Estonie", "code": "233" },
      { "id": 63, "value": "Les États-Unis", "text": "États-Unis", "code": "840" },
      { "id": 64, "value": "L'Éthiopie", "text": "Éthiopie", "code": "231" },
      { "id": 65, "value": "Les Fidji", "text": "Fidji", "code": "242" },
      { "id": 66, "value": "La Finlande", "text": "Finlande", "code": "246" },
      { "id": 67, "value": "Le Gabon", "text": "Gabon", "code": "266" },
      { "id": 68, "value": "La Gambie", "text": "Gambie", "code": "270" },
      { "id": 69, "value": "La Géorgie", "text": "Géorgie", "code": "268" },
      { "id": 70, "value": "Le Ghana", "text": "Ghana", "code": "288" },
      { "id": 71, "value": "Gibraltar", "text": "Gibraltar", "code": "292" },
      { "id": 72, "value": "La Grèce", "text": "Grèce", "code": "300" },
      { "id": 73, "value": "Grenade", "text": "Grenade", "code": "308" },
      { "id": 74, "value": "Le Guatemala", "text": "Guatemala", "code": "320" },
      { "id": 75, "value": "Guernesey", "text": "Guernesey", "code": "831" },
      { "id": 76, "value": "La Guinée", "text": "Guinée", "code": "324" },
      { "id": 77, "value": "La Guinée-Bissau", "text": "Guinée-Bissau", "code": "624" },
      { "id": 78, "value": "La Guinée équatoriale", "text": "Guinée équatoriale", "code": "226" },
      { "id": 79, "value": "Le Guyana", "text": "Guyana", "code": "328" },
      { "id": 80, "value": "Haïti", "text": "Haïti", "code": "332" },
      { "id": 81, "value": "Le Honduras", "text": "Honduras", "code": "340" },
      { "id": 82, "value": "La Hongrie", "text": "Hongrie", "code": "348" },
      { "id": 83, "value": "L'Inde", "text": "Inde", "code": "356" },
      { "id": 84, "value": "L'Indonésie", "text": "Indonésie", "code": "360" },
      { "id": 85, "value": "L'Iran", "text": "Iran", "code": "364" },
      { "id": 86, "value": "L'Irak", "text": "Irak", "code": "368" },
      { "id": 87, "value": "L'Irlande", "text": "Irlande", "code": "372" },
      { "id": 88, "value": "L'Islande", "text": "Islande", "code": "352" },
      { "id": 89, "value": "Israël", "text": "Israël", "code": "376" },
      { "id": 90, "value": "L'Italie", "text": "Italie", "code": "380" },
      { "id": 91, "value": "La Jamaïque", "text": "Jamaïque", "code": "388" },
      { "id": 92, "value": "Le Japon", "text": "Japon", "code": "392" },
      { "id": 93, "value": "La Jordanie", "text": "Jordanie", "code": "400" },
      { "id": 94, "value": "Le Kazakhstan", "text": "Kazakhstan", "code": "398" },
      { "id": 95, "value": "Le Kenya", "text": "Kenya", "code": "404" },
      { "id": 96, "value": "Le Kirghizistan", "text": "Kirghizistan", "code": "417" },
      { "id": 97, "value": "Les Kiribati", "text": "Kiribati", "code": "296" },
      { "id": 98, "value": "Le Koweït", "text": "Koweït", "code": "414" },
      { "id": 99, "value": "Le Kosovo", "text": "Kosovo", "code": "0" },
      { "id": 100, "value": "Le Laos", "text": "Laos", "code": "418" },
      { "id": 101, "value": "Le Lesotho", "text": "Lesotho", "code": "426" },
      { "id": 102, "value": "La Lettonie", "text": "Lettonie", "code": "428" },
      { "id": 103, "value": "Le Liban", "text": "Liban", "code": "422" },
      { "id": 104, "value": "Le Libéria", "text": "Libéria", "code": "430" },
      { "id": 105, "value": "La Libye", "text": "Libye", "code": "434" },
      { "id": 106, "value": "Le Liechtenstein", "text": "Liechtenstein", "code": "438" },
      { "id": 107, "value": "La Lituanie", "text": "Lituanie", "code": "440" },
      { "id": 108, "value": "Le Luxembourg", "text": "Luxembourg", "code": "442" },
      { "id": 109, "value": "La Macédoine", "text": "Macédoine", "code": "807" },
      { "id": 110, "value": "Madagascar", "text": "Madagascar", "code": "450" },
      { "id": 111, "value": "La Malaisie", "text": "Malaisie", "code": "458" },
      { "id": 112, "value": "Le Malawi", "text": "Malawi", "code": "454" },
      { "id": 113, "value": "Les Maldives", "text": "Maldives", "code": "462" },
      { "id": 114, "value": "Le Mali", "text": "Mali", "code": "466" },
      { "id": 115, "value": "Malte", "text": "Malte", "code": "470" },
      { "id": 116, "value": "Les Îles Marshall", "text": "Îles Marshall", "code": "584" },
      { "id": 117, "value": "Le Maroc", "text": "Maroc", "code": "504" },
      { "id": 118, "value": "Maurice", "text": "Maurice", "code": "480" },
      { "id": 119, "value": "La Mauritanie", "text": "Mauritanie", "code": "478" },
      { "id": 120, "value": "Le Mexique", "text": "Mexique", "code": "484" },
      { "id": 121, "value": "La Moldavie", "text": "Moldavie", "code": "498" },
      { "id": 122, "value": "Monaco", "text": "Monaco", "code": "492" },
      { "id": 123, "value": "La Mongolie", "text": "Mongolie", "code": "496" },
      { "id": 124, "value": "Le Monténégro", "text": "Monténégro", "code": "499" },
      { "id": 125, "value": "Le Mozambique", "text": "Mozambique", "code": "508" },
      { "id": 126, "value": "La Namibie", "text": "Namibie", "code": "516" },
      { "id": 127, "value": "Nauru", "text": "Nauru", "code": "520" },
      { "id": 128, "value": "Le Népal", "text": "Népal", "code": "524" },
      { "id": 129, "value": "Le Nicaragua", "text": "Nicaragua", "code": "558" },
      { "id": 130, "value": "Le Niger", "text": "Niger", "code": "562" },
      { "id": 131, "value": "Le Nigéria", "text": "Nigéria", "code": "566" },
      { "id": 132, "value": "Niué", "text": "Niué", "code": "570" },
      { "id": 133, "value": "La Norvège", "text": "Norvège", "code": "578" },
      { "id": 134, "value": "La Nouvelle-Zélande", "text": "Nouvelle-Zélande", "code": "554" },
      { "id": 135, "value": "Oman", "text": "Oman", "code": "512" },
      { "id": 136, "value": "L'Ouganda", "text": "Ouganda", "code": "800" },
      { "id": 137, "value": "L'Ouzbékistan", "text": "Ouzbékistan", "code": "860" },
      { "id": 138, "value": "Le Pakistan", "text": "Pakistan", "code": "586" },
      { "id": 139, "value": "Le Palaos", "text": "Palaos", "code": "585" },
      { "id": 140, "value": "Le Panama", "text": "Panama", "code": "591" },
      { "id": 141, "value": "LaPapouasie-Nouvelle-Guinée", "text": "Papouasie-Nouvelle-Guinée", "code": "598" },
      { "id": 142, "value": "Le Paraguay", "text": "Paraguay", "code": "600" },
      { "id": 143, "value": "Les Pays-Bas", "text": "Pays-Bas", "code": "528" },
      { "id": 144, "value": "Le Pérou", "text": "Pérou", "code": "604" },
      { "id": 145, "value": "Les Philippines", "text": "Philippines", "code": "608" },
      { "id": 146, "value": "La Pologne", "text": "Pologne", "code": "616" },
      { "id": 147, "value": "Porto Rico", "text": "Porto Rico", "code": "630" },
      { "id": 148, "value": "Le Portugal", "text": "Portugal", "code": "620" },
      { "id": 149, "value": "Le Qatar", "text": "Qatar", "code": "634" },
      { "id": 150, "value": "La République dominicaine", "text": "République dominicaine", "code": "214" },
      { "id": 151, "value": "La République tchèque", "text": "République tchèque", "code": "203" },
      { "id": 152, "value": "La Roumanie", "text": "Roumanie", "code": "642" },
      { "id": 153, "value": "Le Royaume-Uni", "text": "Royaume-Uni", "code": "826" },
      { "id": 154, "value": "La Russie", "text": "Russie", "code": "643" },
      { "id": 155, "value": "Le Rwanda", "text": "Rwanda", "code": "646" },
      { "id": 156, "value": "St-Christophe-et-Niévès", "text": "St-Christophe-et-Niévès", "code": "659" },
      { "id": 157, "value": "St-Lucie", "text": "St-Lucie", "code": "662" },
      { "id": 158, "value": "St-Vincent-et-les-Grenadines", "text": "St-Vincent-et-les-Grenadines", "code": "670" },
      { "id": 159, "value": "Saint-Marin", "text": "Saint-Marin", "code": "674" },
      { "id": 160, "value": "Samoa", "text": "Samoa", "code": "882" },
      { "id": 161, "value": "Sao Tomé-et-Principe", "text": "Sao Tomé-et-Principe", "code": "678" },
      { "id": 162, "value": "Le Salvador", "text": "Salvador", "code": "222" },
      { "id": 163, "value": "Le Sénégal", "text": "Sénégal", "code": "686" },
      { "id": 164, "value": "La Serbie", "text": "Serbie", "code": "688" },
      { "id": 165, "value": "Les Seychelles", "text": "Seychelles", "code": "690" },
      { "id": 166, "value": "Le Sierra Leone", "text": "Sierra Leone", "code": "694" },
      { "id": 167, "value": "Singapour", "text": "Singapour", "code": "702" },
      { "id": 168, "value": "La Slovaquie", "text": "Slovaquie", "code": "703" },
      { "id": 169, "value": "La Slovénie", "text": "Slovénie", "code": "705" },
      { "id": 170, "value": "Les Îles Salomon", "text": "Îles Salomon", "code": "090" },
      { "id": 171, "value": "La Somalie", "text": "Somalie", "code": "706" },
      { "id": 172, "value": "Le Soudan", "text": "Soudan", "code": "729" },
      { "id": 173, "value": "Le Soudan du Sud", "text": "Soudan du Sud", "code": "728" },
      { "id": 174, "value": "Le Sri Lanka", "text": "Sri Lanka", "code": "144" },
      { "id": 175, "value": "La Suède", "text": "Suède", "code": "752" },
      { "id": 176, "value": "La Suisse", "text": "Suisse", "code": "756" },
      { "id": 177, "value": "Le Surinam", "text": "Surinam", "code": "740" },
      { "id": 178, "value": "Le Swaziland", "text": "Swaziland", "code": "748" },
      { "id": 179, "value": "La Syrie", "text": "Syrie", "code": "760" },
      { "id": 180, "value": "Le Tadjikistan", "text": "Tadjikistan", "code": "762" },
      { "id": 181, "value": "Taïwan", "text": "Taïwan", "code": "158" },
      { "id": 182, "value": "La Tanzanie", "text": "Tanzanie", "code": "834" },
      { "id": 183, "value": "Le Tchad", "text": "Tchad", "code": "148" },
      { "id": 184, "value": "La Thaïlande", "text": "Thaïlande", "code": "764" },
      { "id": 185, "value": "Le Timor-Oriental", "text": "Timor-Oriental", "code": "626" },
      { "id": 186, "value": "Le Togo", "text": "Togo", "code": "768" },
      { "id": 187, "value": "Le Tonga", "text": "Tonga", "code": "776" },
      { "id": 188, "value": "Le Trinité-et-Tobago", "text": "Trinité-et-Tobago", "code": "780" },
      { "id": 189, "value": "La Tunisie", "text": "Tunisie", "code": "788" },
      { "id": 190, "value": "Le Turkménistan", "text": "Turkménistan", "code": "795" },
      { "id": 191, "value": "La Turquie", "text": "Turquie", "code": "792" },
      { "id": 192, "value": "Les Tuvalu", "text": "Tuvalu", "code": "798" },
      { "id": 193, "value": "L'Ukraine", "text": "Ukraine", "code": "804" },
      { "id": 194, "value": "L'Uruguay", "text": "Uruguay", "code": "858" },
      { "id": 195, "value": "Uzbekistan", "text": "Uzbekistan", "code": "860" },
      { "id": 196, "value": "Le Vanuatu", "text": "Vanuatu", "code": "548" },
      { "id": 197, "value": "Le Venezuela", "text": "Venezuela", "code": "862" },
      { "id": 198, "value": "Le Vietnam", "text": "Vietnam", "code": "704" },
      { "id": 199, "value": "Le Yémen", "text": "Yémen", "code": "887" },
      { "id": 200, "value": "La Zambie", "text": "Zambie", "code": "894" },
      { "id": 201, "value": "Le Zimbabwe", "text": "Zimbabwe", "code": "716" },
      { "id": 202, "value": "Autre", "text": "Autre", "code": "999" }
    ],
    //3 - Catégories socio-professionnelles (CSP/PCS)
    [
      {
        "id": 10,
        "value": "10 - Agriculteurs exploitants",
        "text": "10 - Agriculteurs exploitants"
      },
      {
        "id": 21,
        "value": "21 - Artisans",
        "text": "21 - Artisans"
      },
      {
        "id": 22,
        "value": "22 - Commerçants et assimilés",
        "text": "22 - Commerçants et assimilés"
      },
      {
        "id": 23,
        "value": "23 - Chefs d'entreprise de 10 salariés ou plus",
        "text": "23 - Chefs d'entreprise de 10 salariés ou plus"
      },
      {
        "id": 31,
        "value": "31 - Professions libérales",
        "text": "31 - Professions libérales"
      },
      {
        "id": 33,
        "value": "33 - Cadres de la fonction publique",
        "text": "33 - Cadres de la fonction publique"
      },
      {
        "id": 34,
        "value": "34 - Profeseurs, professions scientifiques",
        "text": "34 - Profeseurs, professions scientifiques"
      },
      {
        "id": 35,
        "value": "35 - Profession de l'informations, des arts et des spectacles",
        "text": "35 - Profession de l'informations, des arts et des spectacles"
      },
      {
        "id": 37,
        "value": "37 - Cadres administratifs et commerciaux d'entreprises",
        "text": "37 - Cadres administratifs et commerciaux d'entreprises"
      },
      {
        "id": 38,
        "value": "38 - Ingénieurs et cadres techniques d'entreprise",
        "text": "38 - Ingénieurs et cadres techniques d'entreprise"
      },
      {
        "id": 42,
        "value": "42 - Instituteurs et assimilés",
        "text": "42 - Instituteurs et assimilés"
      },
      {
        "id": 43,
        "value": "43 - Professions intermédiaires de la santé et du travail social",
        "text": "43 - Professions intermédiaires de la santé et du travail social"
      },
      {
        "id": 44,
        "value": "44 - Clergé, religieux",
        "text": "44 - Clergé, religieux"
      },
      {
        "id": 45,
        "value": "45 - Professions intermédiaires administratives de la fonction publiques",
        "text": "45 - Professions intermédiaires administratives de la fonction publiques"
      },
      {
        "id": 46,
        "value": "46 - Professions intermédiaires administratives et commerciales des entreprises",
        "text": "46 - Professions intermédiaires administratives et commerciales des entreprises"
      },
      {
        "id": 47,
        "value": "47 - Techniciens",
        "text": "47 - Techniciens"
      },
      {
        "id": 48,
        "value": "48 - Contremaitres, agents de maitrise",
        "text": "48 - Contremaitres, agents de maitrise"
      },
      {
        "id": 500,
        "value": "500 - Auto-entrepreneur",
        "text": "500 - Auto-entrepreneur"
      },
      {
        "id": 501,
        "value": "501 - Indépendant",
        "text": "501 - Indépendant"
      },
      {
        "id": 52,
        "value": "52 - Employés civils et agents de service de la fonction publiques",
        "text": "52 - Employés civils et agents de service de la fonction publiques"
      },
      {
        "id": 53,
        "value": "53 - policiers et militaires",
        "text": "53 - policiers et militaires"
      },
      {
        "id": 54,
        "value": "54 - Employés administratifs d'entreprise",
        "text": "54 - Employés administratifs d'entreprise"
      },
      {
        "id": 55,
        "value": "55 - Employés de commerce",
        "text": "55 - Employés de commerce"
      },
      {
        "id": 56,
        "value": "56 - Personnels de services directs aux particuliers",
        "text": "56 - Personnels de services directs aux particuliers"
      },
      {
        "id": 61,
        "value": "61 - Ouvriers qualifiés",
        "text": "61 - Ouvriers qualifiés"
      },
      {
        "id": 66,
        "value": "66 - Ouvriers non-qualifiés",
        "text": "66 - Ouvriers non-qualifiés"
      },
      {
        "id": 69,
        "value": "69 - Ouvriers agricoles",
        "text": "69 - Ouvriers agricoles"
      },
      {
        "id": 71,
        "value": "71 - Retraités Agriulteurs exploitants",
        "text": "71 - Retraités Agriulteurs exploitants"
      },
      {
        "id": 72,
        "value": "72 - Retraités artisans, commerçants, chefs d'entreprise",
        "text": "72 - Retraités artisans, commerçants, chefs d'entreprise"
      },
      {
        "id": 73,
        "value": "73 - Retraités cadres et professions intermédiaires",
        "text": "73 - Retraités cadres et professions intermédiaires"
      },
      {
        "id": 76,
        "value": "76 - Retraités enployés et ouvriers",
        "text": "76 - Retraités enployés et ouvriers"
      },
      {
        "id": 81,
        "value": "81 - Chômeurs n'ayant jamais travaillé",
        "text": "81 - Chômeurs n'ayant jamais travaillé"
      },
      {
        "id": 82,
        "value": "82 - Autres personnes sans activité professionnelle",
        "text": "82 - Autres personnes sans activité professionnelle"
      },
      {
        "id": 90,
        "value": "90 - Etudiant de 3e cycle",
        "text": "90 - Etudiant de 3e cycle"
      },
      {
        "id": 91,
        "value": "91 - Educateur sportif",
        "text": "91 - Educateur sportif"
      },
      {
        "id": 99,
        "value": "99 - Non renseigné",
        "text": "99 - Non renseigné"
      }
    ],
    //4 - Situation maritale
    [
      {
        "id": 1,
        "value": "Célibataire",
        "text": "Célibataire"
      },
      {
        "id": 2,
        "value": "Union libre",
        "text": "Union libre"
      },
      {
        "id": 3,
        "value": "Divorcé(e) ou separé(e)",
        "text": "Divorcé(e) ou séparé(e)"
      },
      {
        "id": 4,
        "value": "Marié(e) ou pacsé(e)",
        "text": "Marié(e) ou pacsé(e)"
      },
      {
        "id": 5,
        "value": "Veuf(ve)",
        "text": "Veuf(ve)"
      }
    ],
    //5 - Échelon de bourse (0 bis à 7)
    [
      {
        "id": 0,
        "value": "0 bis",
        "text": "0 bis"
      },
      {
        "id": 1,
        "value": "1",
        "text": "1"
      },
      {
        "id": 2,
        "value": "2",
        "text": "2"
      },
      {
        "id": 3,
        "value": "3",
        "text": "3"
      },
      {
        "id": 4,
        "value": "4",
        "text": "4"
      },
      {
        "id": 5,
        "value": "5",
        "text": "5"
      },
      {
        "id": 6,
        "value": "6",
        "text": "6"
      },
      {
        "id": 7,
        "value": "7",
        "text": "7"
      }
    ],
    /*---*/
    //6 - Spécialités du bac (enseignements de spécialité)
    [
      {
        "id": 1,
        "value": "CINEMA-AUDIOVISUEL",
        "text": "CINEMA-AUDIOVISUEL"
      },
      {
        "id": 2,
        "value": "ARTS DU CIRQUE",
        "text": "ARTS DU CIRQUE"
      },
      {
        "id": 3,
        "value": "DANSE",
        "text": "DANSE"
      },
      {
        "id": 4,
        "value": "MUSIQUE",
        "text": "MUSIQUE"
      },
      {
        "id": 5,
        "value": "ARTS PLASTIQUES",
        "text": "ARTS PLASTIQUES"
      },
      {
        "id": 6,
        "value": "THEATRE",
        "text": "THEATRE"
      },
      {
        "id": 7,
        "value": "BIOLOGIE-ECOLOGIE (lycées agricoles seulement)",
        "text": "BIOLOGIE-ECOLOGIE (lycées agricoles seulement)"
      },
      {
        "id": 8,
        "value": "HISTOIRE DES ARTS",
        "text": "HISTOIRE DES ARTS"
      },
      {
        "id": 9,
        "value": "HISTOIRE-GEOGRAPHIE, GEOPOLITIQUE ET SCIENCES POLITIQUES",
        "text": "HISTOIRE-GEOGRAPHIE, GEOPOLITIQUE ET SCIENCES POLITIQUES"
      },
      {
        "id": 10,
        "value": "LITTERATURE ET LANGUES ET CULTURES DE L'ANTIQUITE - GREC",
        "text": "LITTERATURE ET LANGUES ET CULTURES DE L'ANTIQUITE - GREC"
      },
      {
        "id": 11,
        "value": "LITTERATURE ET LANGUES ET CULTURES DE L'ANTIQUITE - LATIN",
        "text": "LITTERATURE ET LANGUES ET CULTURES DE L'ANTIQUITE - LATIN"
      },
      {
        "id": 12,
        "value": "HUMANITES, LITTÉRATURE ET PHILOSOPHIE",
        "text": "HUMANITES, LITTÉRATURE ET PHILOSOPHIE"
      },
      {
        "id": 13,
        "value": "LANGUES, LITTÉRATURE ET CULTURES ETRANGERES ET REGIONALES",
        "text": "LANGUES, LITTÉRATURE ET CULTURES ETRANGERES ET REGIONALES"
      },
      {
        "id": 14,
        "value": "MATHEMATIQUES",
        "text": "MATHEMATIQUES"
      },
      {
        "id": 15,
        "value": "NUMERIQUE ET SCIENCES INFORMATIQUES",
        "text": "NUMERIQUE ET SCIENCES INFORMATIQUES"
      },
      {
        "id": 16,
        "value": "PHYSIQUE-CHIMIE",
        "text": "PHYSIQUE-CHIMIE"
      },
      {
        "id": 17,
        "value": "SCIENCES DE L'INGENIEUR ET SCIENCES PHYSIQUES",
        "text": "SCIENCES DE L'INGENIEUR ET SCIENCES PHYSIQUES"
      },
      {
        "id": 18,
        "value": "SCIENCES ECONOMIQUES ET SOCIALES",
        "text": "SCIENCES ECONOMIQUES ET SOCIALES"
      },
      {
        "id": 19,
        "value": "SCIENCES DE LA VIE ET DE LA TERRE",
        "text": "SCIENCES DE LA VIE ET DE LA TERRE"
      },
      {
        "id": 20,
        "value": "EDUC. PHYS., PRATIQUE & CULT. SPORTIVES",
        "text": "EDUC. PHYS., PRATIQUE & CULT. SPORTIVES"
      }
    ],
    //7 - Mention au bac
    [
      {
        "id": 0,
        "value": "Pas de mention",
        "text": "Pas de mention"
      },
      {
        "id": 1,
        "value": "Passable (10)",
        "text": "Passable (10)"
      },
      {
        "id": 2,
        "value": "Assez bien (12)",
        "text": "Assez bien (12)"
      },
      {
        "id": 3,
        "value": "Bien (14)",
        "text": "Bien (14)"
      },
      {
        "id": 4,
        "value": "Très bien (16)",
        "text": "Très bien (16)"
      }
    ],
    //8 - Civilité
    [
      {
        "id": 1,
        "value": "M.",
        "text": "Monsieur"
      },
      {
        "id": 2,
        "value": "Mme",
        "text": "Madame"
      }
    ],
    //9 - Oui (choix unique)
    [
      {
        "id": 1,
        "value": "Oui",
        "text": "Oui"
      }
    ],
    //10 - Oui / Non
    [
      {
        "id": 1,
        "value": "Oui",
        "text": "Oui"
      },
      {
        "id": 2,
        "value": "Non",
        "text": "Non"
      }
    ],

    /*------*/


    //11 - Modalités de paiement
    // eslint-disable-next-line
    [
      {
        "id": 1,
        "value": "disabled 1",
        "text": "---Paiement par prélèvement SEPA---"
      },
      {
        "id": 2,
        "value": "Paiement mensuel par prélèvement SEPA",
        "text": "Paiement par prélèvement SEPA mensuel"
      },
      /*{
        "id": 3,
        "value": "Paiement semestriel par prélèvement SEPA",
        "text": "Paiement par prélèvement SEPA semestriel"
      },
      {
        "id": 4,
        "value": "Paiement annuel par prélèvement SEPA",
        "text": "Paiement par prélèvement SEPA annuel"
      }*/,
      {
        "id": 5,
        "value": "disabled 2",
        "text": "---Paiement par virement---"
      },
      {
        "id": 6,
        "value": "Paiement mensuel par virement",
        "text": "Paiement par virement mensuel"
      },
      {
        "id": 7,
        "value": "Paiement semestriel par virement",
        "text": "Paiement par virement semestriel"
      },
      {
        "id": 8,
        "value": "Paiement annuel par virement",
        "text": "Paiement par virement annuel"
      },
      {
        "id": 9,
        "value": "disabled 3",
        "text": "---Paiement par chèque---"
      },
      /*{
        "id": 10,
        "value": "Paiement mensuel par chèque",
        "text": "Paiement par chèque mensuel"
      },*/
      {
        "id": 11,
        "value": "Paiement semestriel par chèque",
        "text": "Paiement par chèque semestriel"
      },
      {
        "id": 12,
        "value": "Paiement annuel par chèque",
        "text": "Paiement par chèque annuel"
      }
    ],
    //12 - Domiciliation fiscale des revenus en France où à l'Etranger
    [
      {
        "id": 1,
        "value": "Revenus domiciliés fiscalement en France",
        "text": "Revenus domiciliés fiscalement en France"
      },
      {
        "id": 2,
        "value": "Revenus domiciliés fiscalement à l'étranger",
        "text": "Revenus domiciliés fiscalement à l'étranger"
      }
    ],
    //13 - Origine scolaire / établissement précédent (codification SISE)
    [
      {
        "id": 1,
        "value": "A Enseignement secondaire français",
        "text": "A Enseignement secondaire français"
      },
      {
        "id": 2,
        "value": "B BTS (y compris post-BTS)",
        "text": "B BTS (y compris post-BTS)"
      },
      {
        "id": 3,
        "value": "C IUT (y compris post-DUT, licence professionnelle ou BUT)",
        "text": "C IUT (y compris post-DUT, licence professionnelle ou BUT)"
      },
      {
        "id": 4,
        "value": "D CPGE y compris ATS (adaptation technicien supérieur)",
        "text": "D CPGE y compris ATS (adaptation technicien supérieur)"
      },
      {
        "id": 5,
        "value": "E Ecole et formation d’INGÉNIEURS",
        "text": "E Ecole et formation d’INGÉNIEURS"
      },
      {
        "id": 6,
        "value": "G Enseignement supérieur par CORRESPONDANCE",
        "text": "G Enseignement supérieur par CORRESPONDANCE"
      },
      {
        "id": 7,
        "value": "H UNIVERSITÉ et Paris Dauphine (hors IUT, école d’ingénieurs universitaire)",
        "text": "H UNIVERSITÉ et Paris Dauphine (hors IUT, école d’ingénieurs universitaire)"
      },
      {
        "id": 8,
        "value": "J Ecole de MANAGEMENT (école de commerce, gestion)",
        "text": "J Ecole de MANAGEMENT (école de commerce, gestion)"
      },
      {
        "id": 9,
        "value": "K AUTRE ÉTABLISSEMENT SISE l’enseignement supérieur à l’étranger, universitaire ou non (reprise d’études) l’enseignement supérieur en France, universitaire ou non (reprise d’études)",
        "text": "K AUTRE ÉTABLISSEMENT SISE l’enseignement supérieur à l’étranger, universitaire ou non (reprise d’études) l’enseignement supérieur en France, universitaire ou non (reprise d’études)"
      },
      {
        "id": 10,
        "value": "M INSPE",
        "text": "M INSPE"
      },
      {
        "id": 11,
        "value": "P Etablissement ÉTRANGER d’enseignement supérieur ou secondaire",
        "text": "P Etablissement ÉTRANGER d’enseignement supérieur ou secondaire"
      },
      {
        "id": 12,
        "value": "Q Etablissement ÉTRANGER d’enseignement secondaire",
        "text": "Q Etablissement ÉTRANGER d’enseignement secondaire"
      },
      {
        "id": 13,
        "value": "R Etablissement ÉTRANGER d’enseignement supérieur",
        "text": "R Etablissement ÉTRANGER d’enseignement supérieur"
      },
      {
        "id": 14,
        "value": "S AUTRE ETABLISSEMENT ou cursus (en France) supérieur (prise d’études différée)",
        "text": "S AUTRE ETABLISSEMENT ou cursus (en France) supérieur (prise d’études différée)"
      },
      {
        "id": 15,
        "value": "T NON SCOLARISÉ l’année précédente ET JAMAIS ENTRÉ dans l’enseignement",
        "text": "T NON SCOLARISÉ l’année précédente ET JAMAIS ENTRÉ dans l’enseignement"
      },
      {
        "id": 16,
        "value": "U NON SCOLARISÉ l’année précédente MAIS PRECEDEMMENT ENTRÉ dans l’enseignement",
        "text": "U NON SCOLARISÉ l’année précédente MAIS PRECEDEMMENT ENTRÉ dans l’enseignement"
      },
      {
        "id": 17,
        "value": "W NON SCOLARISÉ l’année précédente MAIS PRECEDEMMENT ENTRÉ dans l’enseignement",
        "text": "W NON SCOLARISÉ l’année précédente MAIS PRECEDEMMENT ENTRÉ dans l’enseignement"
      }
    ],
    //14 - Série ou type de baccalauréat (codification)
    [
      { "id": 1, "value": "GENERAL - BAC GENERAL", "text": "GENERAL - BAC GENERAL" },
      { "id": 2, "value": "F11 - MUSIQUE et TMD Musique TMD Musique TMD Musique", "text": "F11 - MUSIQUE et TMD Musique TMD Musique TMD Musique" },
      { "id": 3, "value": "F11P - DANSE et TMD Danse TMD Danse TMD Danse", "text": "F11P - DANSE et TMD Danse TMD Danse TMD Danse" },
      { "id": 4, "value": "F12 - ARTS APPLIQUES (session antérieure ou égale à 1998)", "text": "F12 - ARTS APPLIQUES (session antérieure ou égale à 1998)" },
      { "id": 5, "value": "0021 - BACS PROFESSIONNELS INDUSTRIELS", "text": "0021 - BACS PROFESSIONNELS INDUSTRIELS" },
      { "id": 6, "value": "0022 - BACS PROFESSIONNELS TERTIAIRES", "text": "0022 - BACS PROFESSIONNELS TERTIAIRES" },
      { "id": 7, "value": "HOT - HOTELLERIE", "text": "HOT - HOTELLERIE" },
      { "id": 8, "value": "A - PHILOSOPHIE-LETTRES (OU PHILO, session antérieure à 1984)", "text": "A - PHILOSOPHIE-LETTRES (OU PHILO, session antérieure à 1984)" },
      { "id": 9, "value": "B - ECONOMIQUE ET SOCIAL (OU TECHNIQUE ET ECONOMIE, session antérieure à 1984)", "text": "B - ECONOMIQUE ET SOCIAL (OU TECHNIQUE ET ECONOMIE, session antérieure à 1984)" },
      { "id": 10, "value": "A1 - LETTRES-SCIENCES", "text": "A1 - LETTRES-SCIENCES" },
      { "id": 11, "value": "A2 - LETTRES-LANGUES", "text": "A2 - LETTRES-LANGUES" },
      { "id": 12, "value": "A3 - LETTRES-ARTS PLASTIQUES", "text": "A3 - LETTRES-ARTS PLASTIQUES" },
      { "id": 13, "value": "A4 - LANGUES MATHEMATIQUES (jusque session 1985)", "text": "A4 - LANGUES MATHEMATIQUES (jusque session 1985)" },
      { "id": 14, "value": "A5 - LANGUES (jusque session 1985)", "text": "A5 - LANGUES (jusque session 1985)" },
      { "id": 15, "value": "A6 - EDUCATION MUSICALE (session antérieure à 1984)", "text": "A6 - EDUCATION MUSICALE (session antérieure à 1984)" },
      { "id": 16, "value": "A7 - ARTS PLASTIQUES (session antérieure à 1984)", "text": "A7 - ARTS PLASTIQUES (session antérieure à 1984)" },
      { "id": 17, "value": "C - MATHEMATIQUES ET SCIENCES PHYSIQUES (OU MATHEMATIQUES ELEMENTAIRES, session antérieure à 1984)", "text": "C - MATHEMATIQUES ET SCIENCES PHYSIQUES (OU MATHEMATIQUES ELEMENTAIRES, session antérieure à 1984)" },
      { "id": 18, "value": "D - MATHEMATIQUES ET SCIENCES DE LA NATURE (OU SCIENCES EXPERIMENTALES, session antérieure à 1984)", "text": "D - MATHEMATIQUES ET SCIENCES DE LA NATURE (OU SCIENCES EXPERIMENTALES, session antérieure à 1984)" },
      { "id": 19, "value": "DP - SCIENCES AGRONOMIQUES ET TECHNIQUES", "text": "DP - SCIENCES AGRONOMIQUES ET TECHNIQUES" },
      { "id": 20, "value": "E - MATHEMATIQUES ET TECHNIQUES", "text": "E - MATHEMATIQUES ET TECHNIQUES" },
      { "id": 21, "value": "F1 - CONSTRUCTION MECANIQUE", "text": "F1 - CONSTRUCTION MECANIQUE" },
      { "id": 22, "value": "F2 - ELECTRONIQUE", "text": "F2 - ELECTRONIQUE" },
      { "id": 23, "value": "F3 - ELECTROTECHNIQUE", "text": "F3 - ELECTROTECHNIQUE" },
      { "id": 24, "value": "F4 - GENIE CIVIL", "text": "F4 - GENIE CIVIL" },
      { "id": 25, "value": "F5 - PHYSIQUE", "text": "F5 - PHYSIQUE" },
      { "id": 26, "value": "F6 - CHIMIE", "text": "F6 - CHIMIE" },
      { "id": 27, "value": "F7 - BIOLOGIE OPTION BIOCHIMIE", "text": "F7 - BIOLOGIE OPTION BIOCHIMIE" },
      { "id": 28, "value": "F7P - BIOLOGIE OPTION BIOLOGIE", "text": "F7P - BIOLOGIE OPTION BIOLOGIE" },
      { "id": 29, "value": "F8 - SCIENCES MEDICO-SOCIALES", "text": "F8 - SCIENCES MEDICO-SOCIALES" },
      { "id": 30, "value": "F9 - EQUIPEMENT TECHNIQUE – BATIMENT", "text": "F9 - EQUIPEMENT TECHNIQUE – BATIMENT" },
      { "id": 31, "value": "F10 - MICROTECHNIQUE (session antérieure à 1984)", "text": "F10 - MICROTECHNIQUE (session antérieure à 1984)" },
      { "id": 32, "value": "F10A - MICROTECHNIQUE OPTION APPAREILLAGE", "text": "F10A - MICROTECHNIQUE OPTION APPAREILLAGE" },
      { "id": 33, "value": "F10B - MICROTECHNIQUE OPTION OPTIQUE", "text": "F10B - MICROTECHNIQUE OPTION OPTIQUE" },
      { "id": 34, "value": "F - SPECIALITE NON PRECISEE", "text": "F - SPECIALITE NON PRECISEE" },
      { "id": 35, "value": "G1 - TECHNIQUES ADMINISTRATIVES", "text": "G1 - TECHNIQUES ADMINISTRATIVES" },
      { "id": 36, "value": "G2 - TECHNIQUES QUANTITATIVES DE GESTION", "text": "G2 - TECHNIQUES QUANTITATIVES DE GESTION" },
      { "id": 37, "value": "G3 - TECHNIQUES COMMERCIALES", "text": "G3 - TECHNIQUES COMMERCIALES" },
      { "id": 38, "value": "G - SPECIALITE NON PRECISEE", "text": "G - SPECIALITE NON PRECISEE" },
      { "id": 39, "value": "H - TECHNIQUES INFORMATIQUES", "text": "H - TECHNIQUES INFORMATIQUES" },
      { "id": 40, "value": "S - SCIENTIFIQUE", "text": "S - SCIENTIFIQUE" },
      { "id": 41, "value": "L - LITTERAIRE", "text": "L - LITTERAIRE" },
      { "id": 42, "value": "ES - ECONOMIQUE ET SOCIALE", "text": "ES - ECONOMIQUE ET SOCIALE" },
      { "id": 43, "value": "STI - SCIENCES ET TECHNIQUES INDUSTRIELLES", "text": "STI - SCIENCES ET TECHNIQUES INDUSTRIELLES" },
      { "id": 44, "value": "STT - SCIENCES ET TECHNOLOGIES TERTIAIRES (jusqu'à la session 2006)", "text": "STT - SCIENCES ET TECHNOLOGIES TERTIAIRES (jusqu'à la session 2006)" },
      { "id": 45, "value": "STG - SCIENCES ET TECHNOLOGIES DE LA GESTION (depuis session 2007)", "text": "STG - SCIENCES ET TECHNOLOGIES DE LA GESTION (depuis session 2007)" },
      { "id": 46, "value": "STMG - SCIENCES ET TECHNOLOGIES DU MANAGEMENT ET DE LA GESTION (depuis session 2014)", "text": "STMG - SCIENCES ET TECHNOLOGIES DU MANAGEMENT ET DE LA GESTION (depuis session 2014)" },
      { "id": 47, "value": "STL - SCIENCES ET TECHNOLOGIES DE LABORATOIRE", "text": "STL - SCIENCES ET TECHNOLOGIES DE LABORATOIRE" },
      { "id": 48, "value": "SMS - SCIENCES MEDICO-SOCIALES (jusqu'à la session 2008)", "text": "SMS - SCIENCES MEDICO-SOCIALES (jusqu'à la session 2008)" },
      { "id": 49, "value": "ST2S - SCIENCES ET TECHNOLOGIES DE LA SANTE ET DU SOCIAL (depuis la session 2009)", "text": "ST2S - SCIENCES ET TECHNOLOGIES DE LA SANTE ET DU SOCIAL (depuis la session 2009)" },
      { "id": 50, "value": "STAE - SCIENCES ET TECHNOLOGIE DE L'AGRONOMIE ET DE L'ENVIRONNEMENT", "text": "STAE - SCIENCES ET TECHNOLOGIE DE L'AGRONOMIE ET DE L'ENVIRONNEMENT" },
      { "id": 51, "value": "STPA - SCIENCES ET TECHNOLOGIE DU PRODUIT AGRO-ALIMENTAIRE", "text": "STPA - SCIENCES ET TECHNOLOGIE DU PRODUIT AGRO-ALIMENTAIRE" },
      { "id": 52, "value": "STAV - SCIENCES ET TECHNOLOGIES DE L'AGRONOMIE ET DU VIVANT", "text": "STAV - SCIENCES ET TECHNOLOGIES DE L'AGRONOMIE ET DU VIVANT" },
      { "id": 53, "value": "TD2A - SCIENCES ET TECHNOLOGIES DU DESIGN ET DES ARTS APPLIQUES (depuis session 2013)", "text": "TD2A - SCIENCES ET TECHNOLOGIES DU DESIGN ET DES ARTS APPLIQUES (depuis session 2013)" },
      { "id": 54, "value": "TI2D - SCIENCES ET TECHNOLOGIES DE L'INDUSTRIE ET DU DEVELOPPEMENT DURABLE (depuis session 2013)", "text": "TI2D - SCIENCES ET TECHNOLOGIES DE L'INDUSTRIE ET DU DEVELOPPEMENT DURABLE (depuis session 2013)" },
      { "id": 55, "value": "0023 - BACS PROFESSIONNELS AGRICOLES", "text": "0023 - BACS PROFESSIONNELS AGRICOLES" },
      { "id": 56, "value": "0030 - CAPACITE DE DROIT", "text": "0030 - CAPACITE DE DROIT" },
      { "id": 57, "value": "0031 - TITRE ETRANGER ADMIS NATIONALEMENT EN EQUIVALENCE", "text": "0031 - TITRE ETRANGER ADMIS NATIONALEMENT EN EQUIVALENCE" },
      { "id": 58, "value": "0032 - TITRE FRANCAIS ADMIS NATIONALEMENT EN DISPENSE1", "text": "0032 - TITRE FRANCAIS ADMIS NATIONALEMENT EN DISPENSE1" },
      { "id": 59, "value": "0033 - ESEU A ou D. A. E. U. A", "text": "0033 - ESEU A ou D. A. E. U. A" },
      { "id": 60, "value": "0034 - ESEU B ou D. A. E. U. B", "text": "0034 - ESEU B ou D. A. E. U. B" },
      { "id": 61, "value": "0035 - PROMOTION SOCIALE", "text": "0035 - PROMOTION SOCIALE" },
      { "id": 62, "value": "0036 - VALIDATION D'ETUDES, D'EXPERIENCES PROFESSIONNELLES, D'ACQUIS PERSONNELS", "text": "0036 - VALIDATION D'ETUDES, D'EXPERIENCES PROFESSIONNELLES, D'ACQUIS PERSONNELS" },
      { "id": 63, "value": "0037 - AUTRE CAS DE NON BACHELIERS", "text": "0037 - AUTRE CAS DE NON BACHELIERS" },
      { "id": 64, "value": "0040 - DISPOSITIF BAC -3/+3", "text": "0040 - DISPOSITIF BAC -3/+3" }
    ],
    //15 - Type de diplôme obtenu (codification)
    DIPLOMA_OPTIONS,
    //16 - Pays (liste simple)
    [
      { "id": 1, "value": "France", "text": "France" },
      { "id": 2, "value": "Afghanistan", "text": "Afghanistan" },
      { "id": 3, "value": "Afrique du Sud", "text": "Afrique du Sud" },
      { "id": 4, "value": "Albanie", "text": "Albanie" },
      { "id": 5, "value": "Algérie", "text": "Algérie" },
      { "id": 6, "value": "Allemagne", "text": "Allemagne" },
      { "id": 7, "value": "Andorre", "text": "Andorre" },
      { "id": 8, "value": "Angola", "text": "Angola" },
      { "id": 9, "value": "Antigua-et-Barbuda", "text": "Antigua-et-Barbuda" },
      { "id": 10, "value": "Arabie Saoudite", "text": "Arabie Saoudite" },
      { "id": 11, "value": "Argentine", "text": "Argentine" },
      { "id": 12, "value": "Arménie", "text": "Arménie" },
      { "id": 13, "value": "Aruba", "text": "Aruba" },
      { "id": 14, "value": "Australie", "text": "Australie" },
      { "id": 15, "value": "Autriche", "text": "Autriche" },
      { "id": 16, "value": "Azerbaïdjan", "text": "Azerbaïdjan" },
      { "id": 17, "value": "Bahamas", "text": "Bahamas" },
      { "id": 18, "value": "Bahreïn", "text": "Bahreïn" },
      { "id": 19, "value": "Bangladesh", "text": "Bangladesh" },
      { "id": 20, "value": "Barbade", "text": "Barbade" },
      { "id": 21, "value": "Birmanie", "text": "Birmanie" },
      { "id": 22, "value": "Belgique", "text": "Belgique" },
      { "id": 23, "value": "Belize", "text": "Belize" },
      { "id": 24, "value": "Bénin", "text": "Bénin" },
      { "id": 25, "value": "Bermudes", "text": "Bermudes" },
      { "id": 26, "value": "Bhoutan", "text": "Bhoutan" },
      { "id": 27, "value": "Bolivie", "text": "Bolivie" },
      { "id": 28, "value": "Bosnie-Herzégovine", "text": "Bosnie-Herzégovine" },
      { "id": 29, "value": "Botswana", "text": "Botswana" },
      { "id": 30, "value": "Brésil", "text": "Brésil" },
      { "id": 31, "value": "Brunéi", "text": "Brunéi" },
      { "id": 32, "value": "Bulgarie", "text": "Bulgarie" },
      { "id": 33, "value": "Burkina Faso", "text": "Burkina Faso" },
      { "id": 34, "value": "Burundi", "text": "Burundi" },
      { "id": 35, "value": "Biélorussie", "text": "Biélorussie" },
      { "id": 36, "value": "Cambodge", "text": "Cambodge" },
      { "id": 37, "value": "Cameroun", "text": "Cameroun" },
      { "id": 38, "value": "Canada", "text": "Canada" },
      { "id": 39, "value": "Cap-Vert", "text": "Cap-Vert" },
      { "id": 40, "value": "République centrafricaine", "text": "République centrafricaine" },
      { "id": 41, "value": "Chili", "text": "Chili" },
      { "id": 42, "value": "Chine", "text": "Chine" },
      { "id": 43, "value": "Chypre", "text": "Chypre" },
      { "id": 44, "value": "Colombie", "text": "Colombie" },
      { "id": 45, "value": "Comores", "text": "Comores" },
      { "id": 46, "value": "République du Congo", "text": "République du Congo" },
      { "id": 47, "value": "République démocratique du Congo", "text": "République démocratique du Congo" },
      { "id": 48, "value": "Corée", "text": "Corée" },
      { "id": 49, "value": "Costa Rica", "text": "Costa Rica" },
      { "id": 50, "value": "Côte d’Ivoire", "text": "Côte d’Ivoire" },
      { "id": 51, "value": "Croatie", "text": "Croatie" },
      { "id": 52, "value": "Cuba", "text": "Cuba" },
      { "id": 53, "value": "Danemark", "text": "Danemark" },
      { "id": 54, "value": "Dominique", "text": "Dominique" },
      { "id": 55, "value": "Djibouti", "text": "Djibouti" },
      { "id": 56, "value": "Égypte", "text": "Égypte" },
      { "id": 57, "value": "Émirats arabes unis", "text": "Émirats arabes unis" },
      { "id": 58, "value": "Équateur", "text": "Équateur" },
      { "id": 59, "value": "Érythrée", "text": "Érythrée" },
      { "id": 60, "value": "Espagne", "text": "Espagne" },
      { "id": 61, "value": "Estonie", "text": "Estonie" },
      { "id": 62, "value": "États-Unis", "text": "États-Unis" },
      { "id": 63, "value": "Éthiopie", "text": "Éthiopie" },
      { "id": 64, "value": "Fidji", "text": "Fidji" },
      { "id": 65, "value": "Finlande", "text": "Finlande" },
      { "id": 66, "value": "Gabon", "text": "Gabon" },
      { "id": 67, "value": "Gambie", "text": "Gambie" },
      { "id": 68, "value": "Géorgie", "text": "Géorgie" },
      { "id": 69, "value": "Ghana", "text": "Ghana" },
      { "id": 70, "value": "Gibraltar", "text": "Gibraltar" },
      { "id": 71, "value": "Grèce", "text": "Grèce" },
      { "id": 72, "value": "Grenade", "text": "Grenade" },
      { "id": 73, "value": "Guatemala", "text": "Guatemala" },
      { "id": 74, "value": "Guernesey", "text": "Guernesey" },
      { "id": 75, "value": "Guinée", "text": "Guinée" },
      { "id": 76, "value": "Guinée-Bissau", "text": "Guinée-Bissau" },
      { "id": 77, "value": "Guinée équatoriale", "text": "Guinée équatoriale" },
      { "id": 78, "value": "Guyana", "text": "Guyana" },
      { "id": 79, "value": "Haïti", "text": "Haïti" },
      { "id": 80, "value": "Honduras", "text": "Honduras" },
      { "id": 81, "value": "Hongrie", "text": "Hongrie" },
      { "id": 82, "value": "Îles Marshall", "text": "Îles Marshall" },
      { "id": 83, "value": "Îles Salomon", "text": "Îles Salomon" },
      { "id": 84, "value": "Inde", "text": "Inde" },
      { "id": 85, "value": "Indonésie", "text": "Indonésie" },
      { "id": 86, "value": "Iran", "text": "Iran" },
      { "id": 87, "value": "Irak", "text": "Irak" },
      { "id": 88, "value": "Irlande", "text": "Irlande" },
      { "id": 89, "value": "Islande", "text": "Islande" },
      { "id": 90, "value": "Israël", "text": "Israël" },
      { "id": 91, "value": "Italie", "text": "Italie" },
      { "id": 92, "value": "Jamaïque", "text": "Jamaïque" },
      { "id": 93, "value": "Japon", "text": "Japon" },
      { "id": 94, "value": "Jordanie", "text": "Jordanie" },
      { "id": 95, "value": "Kazakhstan", "text": "Kazakhstan" },
      { "id": 96, "value": "Kenya", "text": "Kenya" },
      { "id": 97, "value": "Kirghizistan", "text": "Kirghizistan" },
      { "id": 98, "value": "Kiribati", "text": "Kiribati" },
      { "id": 99, "value": "Koweït", "text": "Koweït" },
      { "id": 100, "value": "Kosovo", "text": "Kosovo" },
      { "id": 101, "value": "Laos", "text": "Laos" },
      { "id": 102, "value": "Lesotho", "text": "Lesotho" },
      { "id": 103, "value": "Lettonie", "text": "Lettonie" },
      { "id": 104, "value": "Liban", "text": "Liban" },
      { "id": 105, "value": "Libéria", "text": "Libéria" },
      { "id": 106, "value": "Libye", "text": "Libye" },
      { "id": 107, "value": "Liechtenstein", "text": "Liechtenstein" },
      { "id": 108, "value": "Lituanie", "text": "Lituanie" },
      { "id": 109, "value": "Luxembourg", "text": "Luxembourg" },
      { "id": 110, "value": "Macédoine", "text": "Macédoine" },
      { "id": 111, "value": "Madagascar", "text": "Madagascar" },
      { "id": 112, "value": "Malaisie", "text": "Malaisie" },
      { "id": 113, "value": "Malawi", "text": "Malawi" },
      { "id": 114, "value": "Maldives", "text": "Maldives" },
      { "id": 115, "value": "Mali", "text": "Mali" },
      { "id": 116, "value": "Malte", "text": "Malte" },
      { "id": 117, "value": "Maroc", "text": "Maroc" },
      { "id": 118, "value": "Maurice", "text": "Maurice" },
      { "id": 119, "value": "Mauritanie", "text": "Mauritanie" },
      { "id": 120, "value": "Mexique", "text": "Mexique" },
      { "id": 121, "value": "Moldavie", "text": "Moldavie" },
      { "id": 122, "value": "Monaco", "text": "Monaco" },
      { "id": 123, "value": "Mongolie", "text": "Mongolie" },
      { "id": 124, "value": "Monténégro", "text": "Monténégro" },
      { "id": 125, "value": "Mozambique", "text": "Mozambique" },
      { "id": 126, "value": "Namibie", "text": "Namibie" },
      { "id": 127, "value": "Nauru", "text": "Nauru" },
      { "id": 128, "value": "Népal", "text": "Népal" },
      { "id": 129, "value": "Nicaragua", "text": "Nicaragua" },
      { "id": 130, "value": "Niger", "text": "Niger" },
      { "id": 131, "value": "Nigéria", "text": "Nigéria" },
      { "id": 132, "value": "Niué", "text": "Niué" },
      { "id": 133, "value": "Norvège", "text": "Norvège" },
      { "id": 134, "value": "Nouvelle-Zélande", "text": "Nouvelle-Zélande" },
      { "id": 135, "value": "Oman", "text": "Oman" },
      { "id": 136, "value": "Ouganda", "text": "Ouganda" },
      { "id": 137, "value": "Ouzbékistan", "text": "Ouzbékistan" },
      { "id": 138, "value": "Pakistan", "text": "Pakistan" },
      { "id": 139, "value": "Palaos", "text": "Palaos" },
      { "id": 140, "value": "La Palestine", "text": "La Palestine" },
      { "id": 141, "value": "Panama", "text": "Panama" },
      { "id": 142, "value": "Papouasie-Nouvelle-Guinée", "text": "Papouasie-Nouvelle-Guinée" },
      { "id": 143, "value": "Paraguay", "text": "Paraguay" },
      { "id": 144, "value": "Pays-Bas", "text": "Pays-Bas" },
      { "id": 145, "value": "Pérou", "text": "Pérou" },
      { "id": 146, "value": "Philippines", "text": "Philippines" },
      { "id": 147, "value": "Pologne", "text": "Pologne" },
      { "id": 148, "value": "Porto Rico", "text": "Porto Rico" },
      { "id": 149, "value": "Portugal", "text": "Portugal" },
      { "id": 150, "value": "Qatar", "text": "Qatar" },
      { "id": 151, "value": "République dominicaine", "text": "République dominicaine" },
      { "id": 152, "value": "République tchèque", "text": "République tchèque" },
      { "id": 153, "value": "Roumanie", "text": "Roumanie" },
      { "id": 154, "value": "Royaume-Uni", "text": "Royaume-Uni" },
      { "id": 155, "value": "Russie", "text": "Russie" },
      { "id": 156, "value": "Rwanda", "text": "Rwanda" },
      { "id": 157, "value": "St-Christophe-et-Niévès", "text": "St-Christophe-et-Niévès" },
      { "id": 158, "value": "St-Lucie", "text": "St-Lucie" },
      { "id": 159, "value": "St-Vincent-et-les-Grenadines", "text": "St-Vincent-et-les-Grenadines" },
      { "id": 160, "value": "Saint-Marin", "text": "Saint-Marin" },
      { "id": 161, "value": "Samoa", "text": "Samoa" },
      { "id": 162, "value": "Sao Tomé-et-Principe", "text": "Sao Tomé-et-Principe" },
      { "id": 163, "value": "Salvador", "text": "Salvador" },
      { "id": 164, "value": "Sénégal", "text": "Sénégal" },
      { "id": 165, "value": "Serbie", "text": "Serbie" },
      { "id": 166, "value": "Seychelles", "text": "Seychelles" },
      { "id": 167, "value": "Sierra Leone", "text": "Sierra Leone" },
      { "id": 168, "value": "Singapour", "text": "Singapour" },
      { "id": 169, "value": "Slovaquie", "text": "Slovaquie" },
      { "id": 170, "value": "Slovénie", "text": "Slovénie" },
      { "id": 171, "value": "Somalie", "text": "Somalie" },
      { "id": 172, "value": "Soudan", "text": "Soudan" },
      { "id": 173, "value": "Soudan du Sud", "text": "Soudan du Sud" },
      { "id": 174, "value": "Sri Lanka", "text": "Sri Lanka" },
      { "id": 175, "value": "Suède", "text": "Suède" },
      { "id": 176, "value": "Suisse", "text": "Suisse" },
      { "id": 177, "value": "Surinam", "text": "Surinam" },
      { "id": 178, "value": "Swaziland", "text": "Swaziland" },
      { "id": 179, "value": "Syrie", "text": "Syrie" },
      { "id": 180, "value": "Tadjikistan", "text": "Tadjikistan" },
      { "id": 181, "value": "Taïwan", "text": "Taïwan" },
      { "id": 182, "value": "Tanzanie", "text": "Tanzanie" },
      { "id": 183, "value": "Tchad", "text": "Tchad" },
      { "id": 184, "value": "Thaïlande", "text": "Thaïlande" },
      { "id": 185, "value": "Timor-Oriental", "text": "Timor-Oriental" },
      { "id": 186, "value": "Togo", "text": "Togo" },
      { "id": 187, "value": "Tonga", "text": "Tonga" },
      { "id": 188, "value": "Trinité-et-Tobago", "text": "Trinité-et-Tobago" },
      { "id": 189, "value": "Tunisie", "text": "Tunisie" },
      { "id": 190, "value": "Turkménistan", "text": "Turkménistan" },
      { "id": 191, "value": "Turquie", "text": "Turquie" },
      { "id": 192, "value": "Tuvalu", "text": "Tuvalu" },
      { "id": 193, "value": "Ukraine", "text": "Ukraine" },
      { "id": 194, "value": "Uruguay", "text": "Uruguay" },
      { "id": 195, "value": "Uzbekistan", "text": "Uzbekistan" },
      { "id": 196, "value": "Vanuatu", "text": "Vanuatu" },
      { "id": 197, "value": "Venezuela", "text": "Venezuela" },
      { "id": 198, "value": "Vietnam", "text": "Vietnam" },
      { "id": 199, "value": "Yémen", "text": "Yémen" },
      { "id": 200, "value": "Zambie", "text": "Zambie" },
      { "id": 201, "value": "Zimbabwe", "text": "Zimbabwe" },
      { "id": 202, "value": "Autre", "text": "Autre" }

    ],
    //17: APEL
    [
      {
        "id": 1,
        "value": "true",
        "text": "Oui"
      },
      {
        "id": 2,
        "value": "false",
        "text": "Non"
      }
    ]
  ]

  useEffect(() => {
    // Écouter les changements dans le localStorage
    const handleStorageChange = (event) => {
      if (event.key === "questionDataUpdate") {
        // Recharger les données à partir du localStorage
        const updatedData = JSON.parse(event.newValue);
        updateLocalState(updatedData);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setValue(normalizeSalesforceValue(questionInfo.idForm, questionInfo.value) ?? "");
  }, [questionInfo.idForm, questionInfo.value]);

  /* ------------------------------------------------------------ COMPORTEMENT ------------------------------------------------------------ */

  useEffect(() => {
    try {
      const currentQuestion = questions?.[questionIndex];
      const currentVisible =
        typeof currentQuestion?.visiblepourcentage === "boolean"
          ? currentQuestion.visiblepourcentage
          : (typeof currentQuestion?.visible === "boolean" ? currentQuestion.visible : true);
      if (currentVisible !== visible) {
        updateQuestionVisible(getNumberCritereActif, sousCritereIndex, questionIndex, visible);
      }
    } catch {
    }
    checkDependance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, getNumberFiliereActif, getNumberCritereActif, sousCritereIndex, questionIndex, visible]);

  function getFirstOptionValue(question) {
    const options = typeof question?.Options === "number"
      ? listePredef[question.Options]
      : question?.Options;
    if (!Array.isArray(options) || options.length === 0) return "";
    const [firstOption] = options;
    return firstOption?.value ?? "";
  }

  /* eslint-disable no-loop-func */
  function checkDependance() {
    let visibles;
    let NumDependance = 0;
    let ValueDependance = 0;
    let NumDependance2 = 0;
    let ValueDependance2 = 0;

    for (let i = 0; i < questions.length; i++) {
      try {
        const currentQuestion = questions[i];

        if (currentQuestion.Dépendance && currentQuestion.Dépendance.length >= 2) {
          NumDependance = currentQuestion.Dépendance[0];
          ValueDependance = currentQuestion.Dépendance[1];

          const questionDependante = questionLookup.get(String(NumDependance));
          if (!questionDependante) continue;

          visibles = questionDependante.value === ValueDependance;

          // Si Dépendance2 existe, on ajoute la vérification
          if (currentQuestion.Dépendance2 && currentQuestion.Dépendance2.length >= 2) {
            NumDependance2 = currentQuestion.Dépendance2[0];
            ValueDependance2 = currentQuestion.Dépendance2[1];

            const questionDependante2 = questionLookup.get(String(NumDependance2));
            if (!questionDependante2) continue;

            visibles = visibles && (questionDependante2.value === ValueDependance2);
          }

          const currentVisible =
            typeof currentQuestion.visiblepourcentage === "boolean"
              ? currentQuestion.visiblepourcentage
              : (typeof currentQuestion.visible === "boolean" ? currentQuestion.visible : true);
          const element = document.getElementById("id:" + currentQuestion.id);
          if (element) {
            element.style = visibles ? "display:block" : "display:none";
            if (!visibles) {
              const hiddenValue = currentQuestion.defaultWhenHidden === "firstOption"
                ? getFirstOptionValue(currentQuestion)
                : "";
              if (currentQuestion.value !== hiddenValue) {
                currentQuestion.value = hiddenValue;
                if (i === questionIndex) {
                  setValue(hiddenValue);
                }
              }
            } else if (
              currentQuestion.defaultWhenHidden === "firstOption"
              && currentVisible === false
              && currentQuestion.value === getFirstOptionValue(currentQuestion)
            ) {
              if (currentQuestion.value !== "") {
                currentQuestion.value = "";
                if (i === questionIndex) {
                  setValue("");
                }
              }
            }
          }
          if (currentVisible !== visibles) {
            updateQuestionVisible(getNumberCritereActif, sousCritereIndex, i, visibles);
          }
        }

      } catch (error) {
        console.error("Erreur dans checkDependance pour la question index " + i + " :", error);
      }
    }
  }

  // checkDependance();
  /* eslint-disable no-loop-func */

  const nationalitesEuropeennes = [
    "Allemande", "Autrichienne", "Belge", "Bulgare", "Chypriote, Cypriote",
    "Croate", "Danoise", "Espagnole", "Estonienne", "Finlandaise",
    "Grec - Grecque", "Hongroise", "Irlandaise", "Italienne", "Lettonne",
    "Lituanienne", "Luxembourgeoise", "Maltaise", "Néerlandaise", "Polonaise",
    "Portugaise", "Roumaine", "Slovaque", "Slovène", "Suédoise", "Tchèque"
  ];

  const handleChange = async (event) => {
    const newValue = event.target.value;
    setValue(newValue);
    const updatedData = updateQuestionValue(sousCritereIndex, questionIndex, newValue);

    if (event.target.options[event.target.selectedIndex].getAttribute('code')) {
      const newCode = event.target.options[event.target.selectedIndex].getAttribute('code');
      updateQuestionSelectPays(sousCritereIndex, questionIndex, newValue, newCode);
    }

    if (questionInfo.id === 1110) {
      let nationaliteNormalisee = "Étrangère";

      if (newValue === "Française") {
        nationaliteNormalisee = "Française";
      } else if (nationalitesEuropeennes.includes(newValue)) {
        nationaliteNormalisee = "Européenne";
      }

      //console.log("Nationalité normalisée :", nationaliteNormalisee);
      updateFiltreGeneral(nationaliteNormalisee, 4);

      // Tu peux maintenant utiliser cette variable comme tu veux :
      // - la stocker dans le state global
      // - la transmettre à une autre fonction
      // - déclencher une autre logique
    }


    if (questionInfo.id === 513 && String(currentPeriod?.filtres?.[5] || "").trim().toLowerCase().startsWith("alternance") && newValue === "Oui" && paymentExists === true) {
      if (sendDataToServer && updatedData) {
        await sendDataToServer(updatedData);
      }
      window.location.reload();
    }
  };

  function updateLocalState(updatedData) {
    if (updatedData.sousCritereIndex === sousCritereIndex && updatedData.questionIndex === questionIndex) {
      setValue(updatedData.newValue);
    }
  }

  /* ------------------------------------------------------------ AFFICHAGE ------------------------------------------------------------ */

  if (!visible) return null;

  const isAcceptanceReminder = questionInfo.nom === "Acceptation"
    && typeof questionInfo.etiquette === "string"
    && questionInfo.etiquette.toLowerCase().includes("contrat étudiant");

  const acceptancePaymentReminderText = `Le déclarant est informé que les documents et informations transmis sont certifiés exacts et complets. Toute fausse déclaration ou omission engage la responsabilité de son auteur et est susceptible d'entraîner des sanctions.

⚠️ POUR LES ALTERNANTS : aucun paiement n'est requis. Veuillez consulter la procédure ci-dessous selon votre situation.

1) Inscription ou réinscription avec un nouveau contrat d'alternance
Vérifiez attentivement votre dossier avant de répondre « Oui » à la question ci-dessous.
Contactez le 02 51 46 12 13 et demandez le service des facultés afin que le paiement soit désactivé et que vous puissiez poursuivre votre inscription. 

2) Réinscription avec poursuite du même contrat d'alternance
Vérifiez attentivement votre dossier avant de répondre « Oui » à la question ci-dessous.

Attention : après validation de votre réponse, votre dossier sera immédiatement verrouillé et basculera automatiquement vers la signature électronique des documents d'inscription. Aucune modification ne pourra être effectuée.`;

  return (
    <div className="question" id={"id:" + questionInfo.id} style={{ display: "block" }}>
      <label className="questionTitle">
        {questionInfo.etiquette} :{questionInfo.required === "required" ? " *" : ""}
      </label>
      <div>
        {!isAcceptanceReminder && (
          <div className="QuestionHelp" dangerouslySetInnerHTML={{ __html: questionInfo.QuestionHelp }} />
        )}
        {isAcceptanceReminder ? (
          <div className="paymentReminder" role="note" aria-live="polite">
            <p className="paymentReminderText">{acceptancePaymentReminderText}</p>
          </div>
        ) : null}
        {isAcceptanceReminder && questionInfo.QuestionHelp ? (
          <div className="acceptanceReminder" role="note" aria-live="polite">
            <p className="acceptanceReminderText" dangerouslySetInnerHTML={{ __html: questionInfo.QuestionHelp }} />
          </div>
        ) : null}
        {/*Affiche la liste et options contenu dans la questionInfo*/}
        <select
          id={questionInfo.idForm}
          name={questionInfo.idForm}
          type={questionInfo.type}
          className="text"
          required={questionInfo.required}
          placeholder={questionInfo.placeholder}
          pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
          value={value}
          onChange={handleChange}
        >
          <option key={0} value="">{data?.configuration === 'Echange' ? 'Select an option' : '-'}</option>
          {(typeof questionInfo.Options === "number" ? listePredef[questionInfo.Options] : questionInfo.Options).map((option) => {
            const optionValue = option?.value ?? "";
            const isDisabled = String(optionValue).toLowerCase().includes("disabled");
            return (
              <option
                key={option.id}
                value={optionValue}
                code={option.code}
                disabled={isDisabled}
              >
                {option.text}
              </option>
            );
          })}
        </select>
      </div>

    </div>
  );

}
